export const SCENE_ANIMATION_1 = {
    "items": [
        {
            "time": 0.019999999552965165,
            "data": [
                "prisoner,0.143,0.600,4.478,0.000,0.968,0.000,0.253",
                "victimM,3.547,0.600,1.445,0.000,-0.766,0.000,0.643",
                "citizenF,-0.187,0.600,-4.207,0.000,-0.017,0.000,1.000",
                "observationCamera,0.499,0.880,3.709,0.049,-0.196,0.009,0.979"
            ]
        },
        {
            "time": 0.029999999329447748,
            "data": [
                "prisoner,0.143,0.600,4.478,0.000,0.968,0.000,0.253",
                "victimM,3.547,0.600,1.445,0.000,-0.766,0.000,0.643",
                "citizenF,-0.187,0.600,-4.207,0.000,-0.017,0.000,1.000",
                "observationCamera,0.499,0.880,3.709,0.049,-0.196,0.009,0.979"
            ]
        },
        {
            "time": 0.04100000113248825,
            "data": [
                "prisoner,0.144,0.600,4.478,0.000,0.968,0.000,0.253",
                "victimM,3.546,0.600,1.445,0.000,-0.766,0.000,0.643",
                "citizenF,-0.187,0.600,-4.206,0.000,-0.017,0.000,1.000",
                "observationCamera,0.500,0.880,3.706,0.049,-0.195,0.009,0.980"
            ]
        },
        {
            "time": 0.05999999865889549,
            "data": [
                "prisoner,0.145,0.600,4.479,0.000,0.968,0.000,0.252",
                "victimM,3.544,0.600,1.445,0.000,-0.766,0.000,0.643",
                "citizenF,-0.187,0.600,-4.206,0.000,-0.016,0.000,1.000",
                "observationCamera,0.502,0.880,3.701,0.049,-0.194,0.009,0.980"
            ]
        },
        {
            "time": 0.07100000232458115,
            "data": [
                "prisoner,0.149,0.600,4.480,0.000,0.968,0.000,0.251",
                "victimM,3.539,0.600,1.444,0.000,-0.767,0.000,0.642",
                "citizenF,-0.187,0.600,-4.205,0.000,-0.015,0.000,1.000",
                "observationCamera,0.506,0.879,3.690,0.049,-0.191,0.009,0.980"
            ]
        },
        {
            "time": 0.07500000298023224,
            "data": [
                "prisoner,0.151,0.600,4.480,0.000,0.968,0.000,0.251",
                "victimM,3.535,0.600,1.444,0.000,-0.767,0.000,0.642",
                "citizenF,-0.187,0.600,-4.204,0.000,-0.014,0.000,1.000",
                "observationCamera,0.510,0.879,3.681,0.049,-0.189,0.009,0.981"
            ]
        },
        {
            "time": 0.08799999952316284,
            "data": [
                "prisoner,0.152,0.600,4.481,0.000,0.968,0.000,0.250",
                "victimM,3.533,0.600,1.444,0.000,-0.767,0.000,0.642",
                "citizenF,-0.187,0.600,-4.203,0.000,-0.014,0.000,1.000",
                "observationCamera,0.511,0.879,3.677,0.049,-0.188,0.009,0.981"
            ]
        },
        {
            "time": 0.10400000214576721,
            "data": [
                "prisoner,0.156,0.600,4.481,0.000,0.968,0.000,0.250",
                "victimM,3.528,0.600,1.443,0.000,-0.768,0.000,0.641",
                "citizenF,-0.187,0.600,-4.202,0.000,-0.013,0.000,1.000",
                "observationCamera,0.516,0.878,3.664,0.049,-0.185,0.009,0.982"
            ]
        },
        {
            "time": 0.12099999934434891,
            "data": [
                "prisoner,0.161,0.600,4.483,0.000,0.969,0.000,0.248",
                "victimM,3.520,0.600,1.443,0.000,-0.768,0.000,0.640",
                "citizenF,-0.187,0.600,-4.200,0.000,-0.011,0.000,1.000",
                "observationCamera,0.524,0.878,3.646,0.049,-0.180,0.009,0.982"
            ]
        },
        {
            "time": 0.13699999451637269,
            "data": [
                "prisoner,0.168,0.600,4.484,0.000,0.969,0.000,0.247",
                "victimM,3.511,0.600,1.442,0.000,-0.769,0.000,0.639",
                "citizenF,-0.187,0.600,-4.197,0.000,-0.009,0.000,1.000",
                "observationCamera,0.532,0.877,3.624,0.049,-0.175,0.008,0.983"
            ]
        },
        {
            "time": 0.1550000011920929,
            "data": [
                "prisoner,0.175,0.600,4.486,0.000,0.970,0.000,0.245",
                "victimM,3.501,0.600,1.441,0.000,-0.770,0.000,0.638",
                "citizenF,-0.187,0.600,-4.195,0.000,-0.006,0.000,1.000",
                "observationCamera,0.541,0.876,3.599,0.049,-0.169,0.008,0.984"
            ]
        },
        {
            "time": 0.17000000178813935,
            "data": [
                "prisoner,0.183,0.600,4.488,0.000,0.970,0.000,0.243",
                "victimM,3.489,0.600,1.440,0.000,-0.771,0.000,0.636",
                "citizenF,-0.188,0.600,-4.191,0.000,-0.003,0.000,1.000",
                "observationCamera,0.553,0.875,3.570,0.049,-0.162,0.008,0.986"
            ]
        },
        {
            "time": 0.18199999630451203,
            "data": [
                "prisoner,0.192,0.600,4.490,0.000,0.971,0.000,0.241",
                "victimM,3.477,0.600,1.439,0.000,-0.772,0.000,0.635",
                "citizenF,-0.188,0.600,-4.188,0.000,0.000,0.000,1.000",
                "observationCamera,0.563,0.874,3.542,0.048,-0.156,0.007,0.987"
            ]
        },
        {
            "time": 0.19599999487400056,
            "data": [
                "prisoner,0.198,0.600,4.492,0.000,0.971,0.000,0.240",
                "victimM,3.468,0.600,1.438,0.000,-0.773,0.000,0.634",
                "citizenF,-0.188,0.600,-4.185,0.000,0.002,0.000,1.000",
                "observationCamera,0.572,0.873,3.520,0.048,-0.150,0.007,0.987"
            ]
        },
        {
            "time": 0.20999999344348908,
            "data": [
                "prisoner,0.207,0.600,4.494,0.000,0.971,0.000,0.237",
                "victimM,3.456,0.600,1.437,0.000,-0.775,0.000,0.632",
                "citizenF,-0.188,0.600,-4.182,0.000,0.005,0.000,1.000",
                "observationCamera,0.583,0.872,3.490,0.048,-0.143,0.007,0.988"
            ]
        },
        {
            "time": 0.2240000069141388,
            "data": [
                "prisoner,0.216,0.600,4.496,0.000,0.972,0.000,0.235",
                "victimM,3.443,0.600,1.435,0.000,-0.776,0.000,0.631",
                "citizenF,-0.188,0.600,-4.178,0.000,0.008,0.000,1.000",
                "observationCamera,0.595,0.871,3.460,0.048,-0.136,0.006,0.990"
            ]
        },
        {
            "time": 0.23800000548362733,
            "data": [
                "prisoner,0.225,0.600,4.498,0.000,0.972,0.000,0.233",
                "victimM,3.429,0.600,1.434,0.000,-0.777,0.000,0.629",
                "citizenF,-0.188,0.600,-4.175,0.000,0.012,0.000,1.000",
                "observationCamera,0.607,0.870,3.428,0.048,-0.128,0.006,0.991"
            ]
        },
        {
            "time": 0.2540000081062317,
            "data": [
                "prisoner,0.235,0.600,4.501,0.000,0.973,0.000,0.231",
                "victimM,3.415,0.600,1.433,0.000,-0.779,0.000,0.628",
                "citizenF,-0.188,0.600,-4.171,0.000,0.015,0.000,1.000",
                "observationCamera,0.620,0.869,3.394,0.047,-0.120,0.005,0.992"
            ]
        },
        {
            "time": 0.2680000066757202,
            "data": [
                "prisoner,0.247,0.600,4.503,0.000,0.974,0.000,0.228",
                "victimM,3.398,0.600,1.431,0.000,-0.780,0.000,0.625",
                "citizenF,-0.188,0.600,-4.166,0.000,0.020,0.000,1.000",
                "observationCamera,0.635,0.867,3.353,0.047,-0.111,0.005,0.993"
            ]
        },
        {
            "time": 0.2800000011920929,
            "data": [
                "prisoner,0.257,0.600,4.506,0.000,0.974,0.000,0.225",
                "victimM,3.382,0.600,1.429,0.000,-0.782,0.000,0.624",
                "citizenF,-0.189,0.600,-4.161,0.000,0.024,0.000,1.000",
                "observationCamera,0.649,0.866,3.316,0.047,-0.102,0.004,0.994"
            ]
        },
        {
            "time": 0.2939999997615814,
            "data": [
                "prisoner,0.267,0.600,4.508,0.000,0.975,0.000,0.223",
                "victimM,3.368,0.600,1.428,0.000,-0.783,0.000,0.622",
                "citizenF,-0.189,0.600,-4.157,0.000,0.027,0.000,1.000",
                "observationCamera,0.661,0.865,3.283,0.047,-0.094,0.004,0.994"
            ]
        },
        {
            "time": 0.30799999833106997,
            "data": [
                "prisoner,0.278,0.600,4.511,0.000,0.975,0.000,0.220",
                "victimM,3.352,0.600,1.426,0.000,-0.785,0.000,0.620",
                "citizenF,-0.189,0.600,-4.153,0.000,0.032,0.000,1.000",
                "observationCamera,0.676,0.864,3.244,0.046,-0.085,0.004,0.995"
            ]
        },
        {
            "time": 0.3230000138282776,
            "data": [
                "prisoner,0.290,0.600,4.514,0.000,0.976,0.000,0.218",
                "victimM,3.335,0.600,1.424,0.000,-0.787,0.000,0.618",
                "citizenF,-0.189,0.600,-4.148,0.000,0.036,0.000,0.999",
                "observationCamera,0.691,0.862,3.203,0.046,-0.076,0.003,0.996"
            ]
        },
        {
            "time": 0.3370000123977661,
            "data": [
                "prisoner,0.302,0.600,4.517,0.000,0.977,0.000,0.215",
                "victimM,3.317,0.600,1.422,0.000,-0.788,0.000,0.615",
                "citizenF,-0.189,0.600,-4.142,0.000,0.041,0.000,0.999",
                "observationCamera,0.707,0.861,3.160,0.046,-0.066,0.003,0.997"
            ]
        },
        {
            "time": 0.35100001096725466,
            "data": [
                "prisoner,0.314,0.600,4.520,0.000,0.977,0.000,0.212",
                "victimM,3.298,0.600,1.420,0.000,-0.790,0.000,0.613",
                "citizenF,-0.189,0.600,-4.137,0.000,0.046,0.000,0.999",
                "observationCamera,0.722,0.859,3.117,0.045,-0.056,0.002,0.997"
            ]
        },
        {
            "time": 0.36800000071525576,
            "data": [
                "prisoner,0.327,0.600,4.523,0.000,0.978,0.000,0.209",
                "victimM,3.279,0.600,1.418,0.000,-0.792,0.000,0.610",
                "citizenF,-0.190,0.600,-4.131,0.000,0.051,0.000,0.999",
                "observationCamera,0.739,0.858,3.072,0.045,-0.045,0.002,0.998"
            ]
        },
        {
            "time": 0.382999986410141,
            "data": [
                "prisoner,0.343,0.600,4.526,0.000,0.979,0.000,0.205",
                "victimM,3.256,0.600,1.416,0.000,-0.794,0.000,0.607",
                "citizenF,-0.190,0.600,-4.124,0.000,0.057,0.000,0.998",
                "observationCamera,0.759,0.856,3.017,0.045,-0.033,0.001,0.998"
            ]
        },
        {
            "time": 0.39500001072883608,
            "data": [
                "prisoner,0.357,0.600,4.530,0.000,0.979,0.000,0.202",
                "victimM,3.236,0.600,1.413,0.000,-0.796,0.000,0.605",
                "citizenF,-0.190,0.600,-4.118,0.000,0.062,0.000,0.998",
                "observationCamera,0.776,0.854,2.969,0.044,-0.022,0.001,0.999"
            ]
        },
        {
            "time": 0.4099999964237213,
            "data": [
                "prisoner,0.369,0.600,4.533,0.000,0.980,0.000,0.199",
                "victimM,3.217,0.600,1.411,0.000,-0.798,0.000,0.602",
                "citizenF,-0.190,0.600,-4.113,0.000,0.067,0.000,0.998",
                "observationCamera,0.792,0.853,2.926,0.044,-0.012,0.000,0.999"
            ]
        },
        {
            "time": 0.42500001192092898,
            "data": [
                "prisoner,0.383,0.600,4.536,0.000,0.981,0.000,0.196",
                "victimM,3.196,0.600,1.409,0.000,-0.800,0.000,0.599",
                "citizenF,-0.190,0.600,-4.106,0.000,0.073,0.000,0.997",
                "observationCamera,0.810,0.851,2.876,0.043,-0.001,0.000,0.999"
            ]
        },
        {
            "time": 0.4399999976158142,
            "data": [
                "prisoner,0.398,0.600,4.539,0.000,0.981,0.000,0.192",
                "victimM,3.174,0.600,1.406,0.000,-0.803,0.000,0.596",
                "citizenF,-0.191,0.600,-4.099,0.000,0.079,0.000,0.997",
                "observationCamera,0.828,0.850,2.824,0.043,0.011,-0.001,0.999"
            ]
        },
        {
            "time": 0.45500001311302187,
            "data": [
                "prisoner,0.413,0.600,4.543,0.000,0.982,0.000,0.188",
                "victimM,3.151,0.600,1.403,0.000,-0.805,0.000,0.593",
                "citizenF,-0.191,0.600,-4.092,0.000,0.086,0.000,0.996",
                "observationCamera,0.847,0.848,2.770,0.042,0.023,-0.001,0.999"
            ]
        },
        {
            "time": 0.4729999899864197,
            "data": [
                "prisoner,0.428,0.600,4.546,0.000,0.983,0.000,0.185",
                "victimM,3.127,0.600,1.400,0.000,-0.807,0.000,0.590",
                "citizenF,-0.191,0.600,-4.085,0.000,0.092,0.000,0.996",
                "observationCamera,0.866,0.846,2.716,0.042,0.035,-0.002,0.999"
            ]
        },
        {
            "time": 0.4880000054836273,
            "data": [
                "prisoner,0.446,0.600,4.551,0.000,0.984,0.000,0.181",
                "victimM,3.100,0.600,1.397,0.000,-0.810,0.000,0.586",
                "citizenF,-0.191,0.600,-4.076,0.000,0.100,0.000,0.995",
                "observationCamera,0.888,0.844,2.653,0.041,0.049,-0.002,0.998"
            ]
        },
        {
            "time": 0.5009999871253967,
            "data": [
                "prisoner,0.461,0.600,4.554,0.000,0.984,0.000,0.177",
                "victimM,3.077,0.600,1.393,0.000,-0.813,0.000,0.583",
                "citizenF,-0.192,0.600,-4.069,0.000,0.107,0.000,0.994",
                "observationCamera,0.907,0.842,2.598,0.041,0.061,-0.003,0.997"
            ]
        },
        {
            "time": 0.515999972820282,
            "data": [
                "prisoner,0.475,0.600,4.557,0.000,0.985,0.000,0.174",
                "victimM,3.056,0.600,1.391,0.000,-0.815,0.000,0.580",
                "citizenF,-0.192,0.600,-4.062,0.000,0.113,0.000,0.994",
                "observationCamera,0.924,0.841,2.550,0.040,0.071,-0.003,0.997"
            ]
        },
        {
            "time": 0.5299999713897705,
            "data": [
                "prisoner,0.490,0.600,4.561,0.000,0.985,0.000,0.170",
                "victimM,3.032,0.600,1.387,0.000,-0.817,0.000,0.576",
                "citizenF,-0.192,0.600,-4.054,0.000,0.120,0.000,0.993",
                "observationCamera,0.943,0.839,2.494,0.040,0.083,-0.004,0.996"
            ]
        },
        {
            "time": 0.5450000166893005,
            "data": [
                "prisoner,0.506,0.600,4.564,0.000,0.986,0.000,0.167",
                "victimM,3.008,0.600,1.384,0.000,-0.820,0.000,0.573",
                "citizenF,-0.193,0.600,-4.046,0.000,0.127,0.000,0.992",
                "observationCamera,0.962,0.837,2.438,0.039,0.095,-0.004,0.995"
            ]
        },
        {
            "time": 0.5600000023841858,
            "data": [
                "prisoner,0.521,0.600,4.568,0.000,0.987,0.000,0.163",
                "victimM,2.983,0.600,1.380,0.000,-0.822,0.000,0.569",
                "citizenF,-0.193,0.600,-4.038,0.000,0.134,0.000,0.991",
                "observationCamera,0.981,0.836,2.382,0.039,0.107,-0.004,0.993"
            ]
        },
        {
            "time": 0.5770000219345093,
            "data": [
                "prisoner,0.537,0.600,4.571,0.000,0.987,0.000,0.159",
                "victimM,2.959,0.600,1.377,0.000,-0.825,0.000,0.566",
                "citizenF,-0.193,0.600,-4.030,0.000,0.142,0.000,0.990",
                "observationCamera,1.000,0.834,2.326,0.038,0.119,-0.005,0.992"
            ]
        },
        {
            "time": 0.5910000205039978,
            "data": [
                "prisoner,0.554,0.600,4.575,0.000,0.988,0.000,0.155",
                "victimM,2.931,0.600,1.373,0.000,-0.828,0.000,0.561",
                "citizenF,-0.193,0.600,-4.020,0.000,0.150,0.000,0.989",
                "observationCamera,1.021,0.832,2.262,0.038,0.132,-0.005,0.991"
            ]
        },
        {
            "time": 0.6039999723434448,
            "data": [
                "prisoner,0.569,0.600,4.578,0.000,0.988,0.000,0.152",
                "victimM,2.907,0.600,1.369,0.000,-0.830,0.000,0.558",
                "citizenF,-0.194,0.600,-4.012,0.000,0.157,0.000,0.988",
                "observationCamera,1.039,0.831,2.208,0.037,0.143,-0.006,0.989"
            ]
        },
        {
            "time": 0.6190000176429749,
            "data": [
                "prisoner,0.582,0.600,4.581,0.000,0.989,0.000,0.149",
                "victimM,2.886,0.600,1.366,0.000,-0.832,0.000,0.554",
                "citizenF,-0.194,0.600,-4.004,0.000,0.164,0.000,0.986",
                "observationCamera,1.054,0.829,2.160,0.037,0.153,-0.006,0.988"
            ]
        },
        {
            "time": 0.6330000162124634,
            "data": [
                "prisoner,0.597,0.600,4.585,0.000,0.989,0.000,0.145",
                "victimM,2.862,0.600,1.362,0.000,-0.835,0.000,0.550",
                "citizenF,-0.194,0.600,-3.996,0.000,0.172,0.000,0.985",
                "observationCamera,1.072,0.827,2.104,0.036,0.164,-0.006,0.986"
            ]
        },
        {
            "time": 0.6480000019073486,
            "data": [
                "prisoner,0.612,0.600,4.588,0.000,0.990,0.000,0.142",
                "victimM,2.838,0.600,1.358,0.000,-0.837,0.000,0.546",
                "citizenF,-0.195,0.600,-3.987,0.000,0.179,0.000,0.984",
                "observationCamera,1.089,0.826,2.050,0.036,0.175,-0.007,0.984"
            ]
        },
        {
            "time": 0.6629999876022339,
            "data": [
                "prisoner,0.627,0.600,4.591,0.000,0.990,0.000,0.138",
                "victimM,2.813,0.600,1.354,0.000,-0.840,0.000,0.542",
                "citizenF,-0.195,0.600,-3.978,0.000,0.187,0.000,0.982",
                "observationCamera,1.107,0.824,1.994,0.035,0.185,-0.007,0.982"
            ]
        },
        {
            "time": 0.6800000071525574,
            "data": [
                "prisoner,0.642,0.600,4.594,0.000,0.991,0.000,0.135",
                "victimM,2.788,0.600,1.350,0.000,-0.843,0.000,0.538",
                "citizenF,-0.195,0.600,-3.969,0.000,0.195,0.000,0.981",
                "observationCamera,1.124,0.823,1.938,0.034,0.196,-0.007,0.980"
            ]
        },
        {
            "time": 0.6949999928474426,
            "data": [
                "prisoner,0.659,0.600,4.598,0.000,0.991,0.000,0.131",
                "victimM,2.760,0.600,1.345,0.000,-0.846,0.000,0.533",
                "citizenF,-0.196,0.600,-3.958,0.000,0.205,0.000,0.979",
                "observationCamera,1.143,0.821,1.874,0.034,0.208,-0.007,0.977"
            ]
        },
        {
            "time": 0.7080000042915344,
            "data": [
                "prisoner,0.673,0.600,4.601,0.000,0.992,0.000,0.128",
                "victimM,2.735,0.600,1.340,0.000,-0.849,0.000,0.529",
                "citizenF,-0.196,0.600,-3.949,0.000,0.213,0.000,0.977",
                "observationCamera,1.160,0.819,1.818,0.033,0.218,-0.008,0.975"
            ]
        },
        {
            "time": 0.7229999899864197,
            "data": [
                "prisoner,0.686,0.600,4.603,0.000,0.992,0.000,0.125",
                "victimM,2.714,0.600,1.336,0.000,-0.851,0.000,0.526",
                "citizenF,-0.196,0.600,-3.941,0.000,0.220,0.000,0.975",
                "observationCamera,1.174,0.818,1.772,0.033,0.227,-0.008,0.973"
            ]
        },
        {
            "time": 0.7379999756813049,
            "data": [
                "prisoner,0.700,0.600,4.606,0.000,0.993,0.000,0.122",
                "victimM,2.690,0.600,1.332,0.000,-0.853,0.000,0.521",
                "citizenF,-0.196,0.600,-3.931,0.000,0.229,0.000,0.974",
                "observationCamera,1.189,0.817,1.718,0.032,0.236,-0.008,0.971"
            ]
        },
        {
            "time": 0.753000020980835,
            "data": [
                "prisoner,0.713,0.600,4.609,0.000,0.993,0.000,0.119",
                "victimM,2.666,0.600,1.327,0.000,-0.856,0.000,0.517",
                "citizenF,-0.197,0.600,-3.921,0.000,0.237,0.000,0.971",
                "observationCamera,1.204,0.815,1.665,0.032,0.246,-0.008,0.969"
            ]
        },
        {
            "time": 0.7680000066757202,
            "data": [
                "prisoner,0.727,0.600,4.612,0.000,0.993,0.000,0.116",
                "victimM,2.642,0.600,1.322,0.000,-0.859,0.000,0.512",
                "citizenF,-0.197,0.600,-3.912,0.000,0.245,0.000,0.969",
                "observationCamera,1.219,0.814,1.613,0.031,0.254,-0.008,0.967"
            ]
        },
        {
            "time": 0.7850000262260437,
            "data": [
                "prisoner,0.740,0.600,4.614,0.000,0.994,0.000,0.113",
                "victimM,2.619,0.600,1.317,0.000,-0.861,0.000,0.508",
                "citizenF,-0.197,0.600,-3.902,0.000,0.254,0.000,0.967",
                "observationCamera,1.232,0.813,1.562,0.030,0.263,-0.008,0.964"
            ]
        },
        {
            "time": 0.7990000247955322,
            "data": [
                "prisoner,0.754,0.600,4.617,0.000,0.994,0.000,0.110",
                "victimM,2.592,0.600,1.311,0.000,-0.864,0.000,0.503",
                "citizenF,-0.198,0.600,-3.891,0.000,0.264,0.000,0.965",
                "observationCamera,1.248,0.811,1.503,0.030,0.272,-0.009,0.962"
            ]
        },
        {
            "time": 0.8119999766349793,
            "data": [
                "prisoner,0.766,0.600,4.619,0.000,0.994,0.000,0.107",
                "victimM,2.570,0.600,1.306,0.000,-0.867,0.000,0.498",
                "citizenF,-0.198,0.600,-3.881,0.000,0.272,0.000,0.962",
                "observationCamera,1.260,0.810,1.456,0.029,0.279,-0.009,0.960"
            ]
        },
        {
            "time": 0.8270000219345093,
            "data": [
                "prisoner,0.777,0.600,4.621,0.000,0.995,0.000,0.105",
                "victimM,2.551,0.600,1.302,0.000,-0.869,0.000,0.495",
                "citizenF,-0.198,0.600,-3.873,0.000,0.279,0.000,0.960",
                "observationCamera,1.270,0.809,1.414,0.029,0.286,-0.009,0.958"
            ]
        },
        {
            "time": 0.8420000076293945,
            "data": [
                "prisoner,0.788,0.600,4.623,0.000,0.995,0.000,0.102",
                "victimM,2.528,0.600,1.297,0.000,-0.872,0.000,0.490",
                "citizenF,-0.199,0.600,-3.863,0.000,0.288,0.000,0.958",
                "observationCamera,1.281,0.808,1.367,0.028,0.292,-0.009,0.956"
            ]
        },
        {
            "time": 0.8569999933242798,
            "data": [
                "prisoner,0.799,0.600,4.625,0.000,0.995,0.000,0.100",
                "victimM,2.507,0.600,1.291,0.000,-0.874,0.000,0.485",
                "citizenF,-0.199,0.600,-3.852,0.000,0.297,0.000,0.955",
                "observationCamera,1.292,0.807,1.320,0.028,0.299,-0.009,0.954"
            ]
        },
        {
            "time": 0.871999979019165,
            "data": [
                "prisoner,0.810,0.600,4.627,0.000,0.995,0.000,0.098",
                "victimM,2.485,0.600,1.286,0.000,-0.877,0.000,0.481",
                "citizenF,-0.200,0.600,-3.842,0.000,0.306,0.000,0.952",
                "observationCamera,1.302,0.806,1.275,0.027,0.305,-0.009,0.952"
            ]
        },
        {
            "time": 0.8889999985694885,
            "data": [
                "prisoner,0.820,0.600,4.629,0.000,0.995,0.000,0.095",
                "victimM,2.464,0.600,1.280,0.000,-0.879,0.000,0.476",
                "citizenF,-0.200,0.600,-3.832,0.000,0.314,0.000,0.949",
                "observationCamera,1.311,0.806,1.231,0.027,0.310,-0.009,0.950"
            ]
        },
        {
            "time": 0.9039999842643738,
            "data": [
                "prisoner,0.831,0.600,4.631,0.000,0.996,0.000,0.093",
                "victimM,2.441,0.600,1.273,0.000,-0.882,0.000,0.471",
                "citizenF,-0.200,0.600,-3.820,0.000,0.324,0.000,0.946",
                "observationCamera,1.320,0.805,1.183,0.027,0.316,-0.009,0.948"
            ]
        },
        {
            "time": 0.9179999828338623,
            "data": [
                "prisoner,0.841,0.600,4.632,0.000,0.996,0.000,0.091",
                "victimM,2.420,0.600,1.268,0.000,-0.885,0.000,0.466",
                "citizenF,-0.201,0.600,-3.810,0.000,0.333,0.000,0.943",
                "observationCamera,1.327,0.804,1.141,0.026,0.320,-0.009,0.947"
            ]
        },
        {
            "time": 0.9330000281333923,
            "data": [
                "prisoner,0.848,0.600,4.633,0.000,0.996,0.000,0.090",
                "victimM,2.403,0.600,1.262,0.000,-0.887,0.000,0.461",
                "citizenF,-0.201,0.600,-3.801,0.000,0.341,0.000,0.940",
                "observationCamera,1.333,0.804,1.106,0.026,0.323,-0.009,0.946"
            ]
        },
        {
            "time": 0.9490000009536743,
            "data": [
                "prisoner,0.856,0.600,4.634,0.000,0.996,0.000,0.088",
                "victimM,2.384,0.600,1.256,0.000,-0.890,0.000,0.457",
                "citizenF,-0.201,0.600,-3.790,0.000,0.350,0.000,0.937",
                "observationCamera,1.338,0.803,1.067,0.025,0.327,-0.009,0.945"
            ]
        },
        {
            "time": 0.9649999737739563,
            "data": [
                "prisoner,0.864,0.600,4.635,0.000,0.996,0.000,0.087",
                "victimM,2.364,0.600,1.249,0.000,-0.892,0.000,0.451",
                "citizenF,-0.202,0.600,-3.779,0.000,0.360,0.000,0.933",
                "observationCamera,1.343,0.803,1.029,0.025,0.329,-0.009,0.944"
            ]
        },
        {
            "time": 0.9810000061988831,
            "data": [
                "prisoner,0.871,0.600,4.635,0.000,0.996,0.000,0.086",
                "victimM,2.346,0.600,1.243,0.000,-0.895,0.000,0.446",
                "citizenF,-0.202,0.600,-3.768,0.000,0.369,0.000,0.930",
                "observationCamera,1.346,0.802,0.994,0.025,0.331,-0.009,0.943"
            ]
        },
        {
            "time": 0.9990000128746033,
            "data": [
                "prisoner,0.877,0.600,4.636,0.000,0.996,0.000,0.085",
                "victimM,2.328,0.600,1.236,0.000,-0.897,0.000,0.441",
                "citizenF,-0.202,0.600,-3.757,0.000,0.378,0.000,0.926",
                "observationCamera,1.348,0.802,0.960,0.024,0.332,-0.009,0.943"
            ]
        },
        {
            "time": 1.0149999856948853,
            "data": [
                "prisoner,0.884,0.600,4.636,0.000,0.996,0.000,0.084",
                "victimM,2.309,0.600,1.229,0.000,-0.900,0.000,0.436",
                "citizenF,-0.203,0.600,-3.744,0.000,0.388,0.000,0.922",
                "observationCamera,1.349,0.802,0.925,0.024,0.333,-0.009,0.943"
            ]
        },
        {
            "time": 1.0290000438690186,
            "data": [
                "prisoner,0.889,0.600,4.636,0.000,0.997,0.000,0.083",
                "victimM,2.292,0.600,1.221,0.000,-0.903,0.000,0.430",
                "citizenF,-0.203,0.600,-3.733,0.000,0.398,0.000,0.918",
                "observationCamera,1.349,0.802,0.895,0.023,0.333,-0.008,0.943"
            ]
        },
        {
            "time": 1.0449999570846558,
            "data": [
                "prisoner,0.893,0.600,4.635,0.000,0.997,0.000,0.082",
                "victimM,2.278,0.600,1.215,0.000,-0.905,0.000,0.425",
                "citizenF,-0.204,0.600,-3.724,0.000,0.405,0.000,0.914",
                "observationCamera,1.348,0.802,0.870,0.023,0.333,-0.008,0.943"
            ]
        },
        {
            "time": 1.059999942779541,
            "data": [
                "prisoner,0.898,0.600,4.634,0.000,0.997,0.000,0.082",
                "victimM,2.261,0.600,1.208,0.000,-0.908,0.000,0.420",
                "citizenF,-0.204,0.600,-3.712,0.000,0.414,0.000,0.910",
                "observationCamera,1.348,0.803,0.841,0.023,0.333,-0.008,0.943"
            ]
        },
        {
            "time": 1.0759999752044678,
            "data": [
                "prisoner,0.902,0.600,4.633,0.000,0.997,0.000,0.081",
                "victimM,2.245,0.600,1.201,0.000,-0.910,0.000,0.414",
                "citizenF,-0.204,0.600,-3.702,0.000,0.423,0.000,0.906",
                "observationCamera,1.347,0.803,0.814,0.022,0.332,-0.008,0.943"
            ]
        },
        {
            "time": 1.0920000076293946,
            "data": [
                "prisoner,0.907,0.600,4.631,0.000,0.997,0.000,0.081",
                "victimM,2.227,0.600,1.193,0.000,-0.913,0.000,0.407",
                "citizenF,-0.205,0.600,-3.691,0.000,0.432,0.000,0.902",
                "observationCamera,1.346,0.804,0.786,0.022,0.332,-0.008,0.943"
            ]
        },
        {
            "time": 1.1100000143051148,
            "data": [
                "prisoner,0.912,0.600,4.629,0.000,0.997,0.000,0.080",
                "victimM,2.210,0.600,1.186,0.000,-0.916,0.000,0.401",
                "citizenF,-0.205,0.600,-3.680,0.000,0.441,0.000,0.897",
                "observationCamera,1.345,0.804,0.760,0.022,0.331,-0.008,0.943"
            ]
        },
        {
            "time": 1.1260000467300416,
            "data": [
                "prisoner,0.917,0.600,4.626,0.000,0.997,0.000,0.079",
                "victimM,2.190,0.600,1.177,0.000,-0.920,0.000,0.393",
                "citizenF,-0.206,0.600,-3.667,0.000,0.451,0.000,0.892",
                "observationCamera,1.343,0.805,0.729,0.021,0.330,-0.008,0.944"
            ]
        },
        {
            "time": 1.1399999856948853,
            "data": [
                "prisoner,0.922,0.600,4.623,0.000,0.997,0.000,0.079",
                "victimM,2.173,0.600,1.169,0.000,-0.923,0.000,0.386",
                "citizenF,-0.206,0.600,-3.656,0.000,0.460,0.000,0.888",
                "observationCamera,1.341,0.806,0.704,0.021,0.330,-0.008,0.944"
            ]
        },
        {
            "time": 1.156000018119812,
            "data": [
                "prisoner,0.926,0.600,4.620,0.000,0.997,0.000,0.078",
                "victimM,2.158,0.600,1.162,0.000,-0.925,0.000,0.379",
                "citizenF,-0.206,0.600,-3.647,0.000,0.467,0.000,0.884",
                "observationCamera,1.339,0.807,0.682,0.021,0.329,-0.007,0.944"
            ]
        },
        {
            "time": 1.1720000505447388,
            "data": [
                "prisoner,0.930,0.600,4.616,0.000,0.997,0.000,0.078",
                "victimM,2.140,0.600,1.154,0.000,-0.928,0.000,0.372",
                "citizenF,-0.207,0.600,-3.636,0.000,0.476,0.000,0.879",
                "observationCamera,1.337,0.808,0.657,0.020,0.328,-0.007,0.944"
            ]
        },
        {
            "time": 1.187999963760376,
            "data": [
                "prisoner,0.935,0.600,4.612,0.000,0.997,0.000,0.077",
                "victimM,2.122,0.600,1.146,0.000,-0.931,0.000,0.364",
                "citizenF,-0.207,0.600,-3.625,0.000,0.485,0.000,0.875",
                "observationCamera,1.335,0.809,0.633,0.020,0.327,-0.007,0.945"
            ]
        },
        {
            "time": 1.2039999961853028,
            "data": [
                "prisoner,0.939,0.600,4.608,0.000,0.997,0.000,0.076",
                "victimM,2.104,0.600,1.137,0.000,-0.935,0.000,0.356",
                "citizenF,-0.207,0.600,-3.614,0.000,0.493,0.000,0.870",
                "observationCamera,1.333,0.811,0.609,0.020,0.326,-0.007,0.945"
            ]
        },
        {
            "time": 1.2230000495910645,
            "data": [
                "prisoner,0.944,0.600,4.603,0.000,0.997,0.000,0.076",
                "victimM,2.086,0.600,1.129,0.000,-0.938,0.000,0.348",
                "citizenF,-0.208,0.600,-3.604,0.000,0.501,0.000,0.865",
                "observationCamera,1.330,0.812,0.586,0.019,0.325,-0.007,0.946"
            ]
        },
        {
            "time": 1.2389999628067017,
            "data": [
                "prisoner,0.949,0.600,4.596,0.000,0.997,0.000,0.075",
                "victimM,2.065,0.600,1.119,0.000,-0.941,0.000,0.338",
                "citizenF,-0.208,0.600,-3.591,0.000,0.511,0.000,0.860",
                "observationCamera,1.327,0.814,0.559,0.019,0.323,-0.007,0.946"
            ]
        },
        {
            "time": 1.2519999742507935,
            "data": [
                "prisoner,0.953,0.600,4.590,0.000,0.997,0.000,0.075",
                "victimM,2.048,0.600,1.110,0.000,-0.944,0.000,0.329",
                "citizenF,-0.208,0.600,-3.581,0.000,0.519,0.000,0.855",
                "observationCamera,1.324,0.815,0.538,0.018,0.322,-0.007,0.947"
            ]
        },
        {
            "time": 1.2680000066757203,
            "data": [
                "prisoner,0.957,0.600,4.585,0.000,0.997,0.000,0.074",
                "victimM,2.033,0.600,1.103,0.000,-0.947,0.000,0.322",
                "citizenF,-0.209,0.600,-3.572,0.000,0.526,0.000,0.851",
                "observationCamera,1.321,0.817,0.519,0.018,0.320,-0.007,0.947"
            ]
        },
        {
            "time": 1.284000039100647,
            "data": [
                "prisoner,0.961,0.600,4.579,0.000,0.997,0.000,0.074",
                "victimM,2.015,0.600,1.094,0.000,-0.950,0.000,0.313",
                "citizenF,-0.209,0.600,-3.562,0.000,0.534,0.000,0.846",
                "observationCamera,1.318,0.818,0.498,0.018,0.319,-0.007,0.948"
            ]
        },
        {
            "time": 1.2999999523162842,
            "data": [
                "prisoner,0.965,0.600,4.572,0.000,0.997,0.000,0.073",
                "victimM,1.997,0.600,1.085,0.000,-0.953,0.000,0.304",
                "citizenF,-0.209,0.600,-3.552,0.000,0.541,0.000,0.841",
                "observationCamera,1.314,0.820,0.478,0.017,0.317,-0.006,0.948"
            ]
        },
        {
            "time": 1.315000057220459,
            "data": [
                "prisoner,0.969,0.600,4.565,0.000,0.997,0.000,0.072",
                "victimM,1.980,0.600,1.076,0.000,-0.956,0.000,0.294",
                "citizenF,-0.210,0.600,-3.541,0.000,0.549,0.000,0.836",
                "observationCamera,1.311,0.822,0.458,0.017,0.316,-0.006,0.949"
            ]
        },
        {
            "time": 1.3329999446868897,
            "data": [
                "prisoner,0.973,0.600,4.557,0.000,0.997,0.000,0.072",
                "victimM,1.962,0.600,1.066,0.000,-0.958,0.000,0.285",
                "citizenF,-0.210,0.600,-3.532,0.000,0.556,0.000,0.831",
                "observationCamera,1.307,0.824,0.439,0.016,0.314,-0.006,0.949"
            ]
        },
        {
            "time": 1.350000023841858,
            "data": [
                "prisoner,0.978,0.600,4.548,0.000,0.997,0.000,0.071",
                "victimM,1.943,0.600,1.056,0.000,-0.962,0.000,0.275",
                "citizenF,-0.211,0.600,-3.520,0.000,0.565,0.000,0.825",
                "observationCamera,1.303,0.826,0.417,0.016,0.312,-0.006,0.950"
            ]
        },
        {
            "time": 1.3619999885559083,
            "data": [
                "prisoner,0.982,0.600,4.540,0.000,0.997,0.000,0.071",
                "victimM,1.924,0.600,1.046,0.000,-0.964,0.000,0.265",
                "citizenF,-0.211,0.600,-3.510,0.000,0.572,0.000,0.820",
                "observationCamera,1.299,0.828,0.397,0.016,0.310,-0.006,0.951"
            ]
        },
        {
            "time": 1.378000020980835,
            "data": [
                "prisoner,0.985,0.600,4.533,0.000,0.998,0.000,0.070",
                "victimM,1.911,0.600,1.038,0.000,-0.966,0.000,0.257",
                "citizenF,-0.211,0.600,-3.503,0.000,0.578,0.000,0.816",
                "observationCamera,1.296,0.830,0.384,0.015,0.308,-0.006,0.951"
            ]
        },
        {
            "time": 1.3930000066757203,
            "data": [
                "prisoner,0.989,0.600,4.524,0.000,0.998,0.000,0.070",
                "victimM,1.895,0.600,1.029,0.000,-0.969,0.000,0.248",
                "citizenF,-0.211,0.600,-3.493,0.000,0.584,0.000,0.811",
                "observationCamera,1.292,0.832,0.366,0.015,0.306,-0.006,0.952"
            ]
        },
        {
            "time": 1.409000039100647,
            "data": [
                "prisoner,0.992,0.600,4.515,0.000,0.998,0.000,0.069",
                "victimM,1.878,0.600,1.019,0.000,-0.971,0.000,0.238",
                "citizenF,-0.212,0.600,-3.484,0.000,0.591,0.000,0.806",
                "observationCamera,1.288,0.834,0.349,0.015,0.304,-0.006,0.952"
            ]
        },
        {
            "time": 1.4240000247955323,
            "data": [
                "prisoner,0.996,0.600,4.506,0.000,0.998,0.000,0.069",
                "victimM,1.861,0.600,1.010,0.000,-0.973,0.000,0.229",
                "citizenF,-0.212,0.600,-3.475,0.000,0.598,0.000,0.802",
                "observationCamera,1.285,0.836,0.332,0.014,0.302,-0.006,0.953"
            ]
        },
        {
            "time": 1.4429999589920045,
            "data": [
                "prisoner,1.000,0.600,4.496,0.000,0.998,0.000,0.068",
                "victimM,1.845,0.600,1.000,0.000,-0.976,0.000,0.219",
                "citizenF,-0.212,0.600,-3.466,0.000,0.604,0.000,0.797",
                "observationCamera,1.281,0.838,0.316,0.014,0.300,-0.006,0.954"
            ]
        },
        {
            "time": 1.4579999446868897,
            "data": [
                "prisoner,1.004,0.600,4.484,0.000,0.998,0.000,0.068",
                "victimM,1.826,0.600,0.988,0.000,-0.978,0.000,0.208",
                "citizenF,-0.213,0.600,-3.456,0.000,0.612,0.000,0.791",
                "observationCamera,1.276,0.840,0.298,0.013,0.298,-0.005,0.954"
            ]
        },
        {
            "time": 1.4709999561309815,
            "data": [
                "prisoner,1.008,0.600,4.473,0.000,0.998,0.000,0.067",
                "victimM,1.810,0.600,0.978,0.000,-0.980,0.000,0.198",
                "citizenF,-0.213,0.600,-3.447,0.000,0.618,0.000,0.786",
                "observationCamera,1.272,0.843,0.282,0.013,0.296,-0.005,0.955"
            ]
        },
        {
            "time": 1.4869999885559083,
            "data": [
                "prisoner,1.011,0.600,4.464,0.000,0.998,0.000,0.067",
                "victimM,1.797,0.600,0.970,0.000,-0.982,0.000,0.190",
                "citizenF,-0.213,0.600,-3.440,0.000,0.623,0.000,0.782",
                "observationCamera,1.268,0.844,0.270,0.013,0.294,-0.005,0.956"
            ]
        },
        {
            "time": 1.503000020980835,
            "data": [
                "prisoner,1.014,0.600,4.453,0.000,0.998,0.000,0.067",
                "victimM,1.781,0.600,0.959,0.000,-0.984,0.000,0.181",
                "citizenF,-0.214,0.600,-3.432,0.000,0.629,0.000,0.778",
                "observationCamera,1.264,0.847,0.255,0.012,0.292,-0.005,0.956"
            ]
        },
        {
            "time": 1.5180000066757203,
            "data": [
                "prisoner,1.018,0.600,4.442,0.000,0.998,0.000,0.066",
                "victimM,1.766,0.600,0.949,0.000,-0.985,0.000,0.171",
                "citizenF,-0.214,0.600,-3.423,0.000,0.634,0.000,0.773",
                "observationCamera,1.260,0.849,0.241,0.012,0.289,-0.005,0.957"
            ]
        },
        {
            "time": 1.534000039100647,
            "data": [
                "prisoner,1.022,0.600,4.430,0.000,0.998,0.000,0.066",
                "victimM,1.751,0.600,0.939,0.000,-0.987,0.000,0.162",
                "citizenF,-0.214,0.600,-3.415,0.000,0.640,0.000,0.768",
                "observationCamera,1.256,0.851,0.227,0.012,0.287,-0.005,0.958"
            ]
        },
        {
            "time": 1.5520000457763672,
            "data": [
                "prisoner,1.025,0.600,4.418,0.000,0.998,0.000,0.065",
                "victimM,1.736,0.600,0.928,0.000,-0.988,0.000,0.153",
                "citizenF,-0.214,0.600,-3.408,0.000,0.645,0.000,0.764",
                "observationCamera,1.252,0.853,0.214,0.011,0.285,-0.005,0.959"
            ]
        },
        {
            "time": 1.5679999589920045,
            "data": [
                "prisoner,1.029,0.600,4.404,0.000,0.998,0.000,0.065",
                "victimM,1.720,0.600,0.916,0.000,-0.990,0.000,0.142",
                "citizenF,-0.215,0.600,-3.399,0.000,0.651,0.000,0.759",
                "observationCamera,1.247,0.856,0.199,0.011,0.282,-0.005,0.959"
            ]
        },
        {
            "time": 1.5809999704360963,
            "data": [
                "prisoner,1.032,0.600,4.391,0.000,0.998,0.000,0.064",
                "victimM,1.705,0.600,0.905,0.000,-0.991,0.000,0.133",
                "citizenF,-0.215,0.600,-3.391,0.000,0.656,0.000,0.754",
                "observationCamera,1.243,0.858,0.186,0.011,0.279,-0.005,0.960"
            ]
        },
        {
            "time": 1.597000002861023,
            "data": [
                "prisoner,1.035,0.600,4.380,0.000,0.998,0.000,0.064",
                "victimM,1.694,0.600,0.896,0.000,-0.992,0.000,0.125",
                "citizenF,-0.215,0.600,-3.385,0.000,0.661,0.000,0.751",
                "observationCamera,1.239,0.860,0.175,0.010,0.277,-0.005,0.961"
            ]
        },
        {
            "time": 1.6119999885559083,
            "data": [
                "prisoner,1.039,0.600,4.367,0.000,0.998,0.000,0.063",
                "victimM,1.680,0.600,0.885,0.000,-0.993,0.000,0.117",
                "citizenF,-0.215,0.600,-3.378,0.000,0.665,0.000,0.746",
                "observationCamera,1.235,0.862,0.163,0.010,0.275,-0.005,0.961"
            ]
        },
        {
            "time": 1.6269999742507935,
            "data": [
                "prisoner,1.042,0.600,4.353,0.000,0.998,0.000,0.063",
                "victimM,1.667,0.600,0.874,0.000,-0.994,0.000,0.108",
                "citizenF,-0.216,0.600,-3.371,0.000,0.670,0.000,0.742",
                "observationCamera,1.232,0.864,0.152,0.010,0.272,-0.005,0.962"
            ]
        },
        {
            "time": 1.6430000066757203,
            "data": [
                "prisoner,1.045,0.600,4.339,0.000,0.998,0.000,0.063",
                "victimM,1.654,0.600,0.863,0.000,-0.995,0.000,0.100",
                "citizenF,-0.216,0.600,-3.365,0.000,0.674,0.000,0.738",
                "observationCamera,1.228,0.866,0.140,0.010,0.270,-0.005,0.963"
            ]
        },
        {
            "time": 1.6610000133514405,
            "data": [
                "prisoner,1.048,0.600,4.325,0.000,0.998,0.000,0.062",
                "victimM,1.642,0.600,0.852,0.000,-0.996,0.000,0.091",
                "citizenF,-0.216,0.600,-3.358,0.000,0.679,0.000,0.734",
                "observationCamera,1.224,0.868,0.129,0.009,0.267,-0.005,0.964"
            ]
        },
        {
            "time": 1.6770000457763672,
            "data": [
                "prisoner,1.052,0.600,4.309,0.000,0.998,0.000,0.062",
                "victimM,1.628,0.600,0.839,0.000,-0.997,0.000,0.082",
                "citizenF,-0.216,0.600,-3.351,0.000,0.683,0.000,0.730",
                "observationCamera,1.220,0.870,0.117,0.009,0.265,-0.005,0.964"
            ]
        },
        {
            "time": 1.690000057220459,
            "data": [
                "prisoner,1.055,0.600,4.294,0.000,0.998,0.000,0.061",
                "victimM,1.616,0.600,0.828,0.000,-0.997,0.000,0.074",
                "citizenF,-0.217,0.600,-3.345,0.000,0.687,0.000,0.726",
                "observationCamera,1.216,0.872,0.107,0.009,0.262,-0.005,0.965"
            ]
        },
        {
            "time": 1.7059999704360963,
            "data": [
                "prisoner,1.058,0.600,4.281,0.000,0.998,0.000,0.061",
                "victimM,1.606,0.600,0.818,0.000,-0.998,0.000,0.068",
                "citizenF,-0.217,0.600,-3.340,0.000,0.691,0.000,0.723",
                "observationCamera,1.213,0.874,0.098,0.009,0.260,-0.005,0.966"
            ]
        },
        {
            "time": 1.7209999561309815,
            "data": [
                "prisoner,1.061,0.600,4.266,0.000,0.998,0.000,0.061",
                "victimM,1.596,0.600,0.807,0.000,-0.998,0.000,0.061",
                "citizenF,-0.217,0.600,-3.334,0.000,0.694,0.000,0.720",
                "observationCamera,1.209,0.876,0.088,0.008,0.257,-0.004,0.966"
            ]
        },
        {
            "time": 1.7369999885559083,
            "data": [
                "prisoner,1.064,0.600,4.250,0.000,0.998,0.000,0.060",
                "victimM,1.585,0.600,0.795,0.000,-0.999,0.000,0.053",
                "citizenF,-0.217,0.600,-3.329,0.000,0.698,0.000,0.716",
                "observationCamera,1.206,0.877,0.079,0.008,0.255,-0.004,0.967"
            ]
        },
        {
            "time": 1.7519999742507935,
            "data": [
                "prisoner,1.067,0.600,4.234,0.000,0.998,0.000,0.060",
                "victimM,1.575,0.600,0.784,0.000,-0.999,0.000,0.047",
                "citizenF,-0.217,0.600,-3.324,0.000,0.701,0.000,0.713",
                "observationCamera,1.203,0.879,0.070,0.008,0.252,-0.004,0.968"
            ]
        },
        {
            "time": 1.7699999809265137,
            "data": [
                "prisoner,1.070,0.600,4.218,0.000,0.998,0.000,0.060",
                "victimM,1.566,0.600,0.772,0.000,-0.999,0.000,0.040",
                "citizenF,-0.217,0.600,-3.319,0.000,0.704,0.000,0.710",
                "observationCamera,1.200,0.881,0.061,0.008,0.250,-0.004,0.968"
            ]
        },
        {
            "time": 1.7860000133514405,
            "data": [
                "prisoner,1.073,0.600,4.200,0.000,0.998,0.000,0.059",
                "victimM,1.555,0.600,0.759,0.000,-0.999,0.000,0.033",
                "citizenF,-0.218,0.600,-3.314,0.000,0.707,0.000,0.707",
                "observationCamera,1.196,0.883,0.051,0.007,0.247,-0.004,0.969"
            ]
        },
        {
            "time": 1.7990000247955323,
            "data": [
                "prisoner,1.076,0.600,4.183,0.000,0.998,0.000,0.059",
                "victimM,1.547,0.600,0.747,0.000,-1.000,0.000,0.027",
                "citizenF,-0.218,0.600,-3.310,0.000,0.710,0.000,0.704",
                "observationCamera,1.193,0.884,0.043,0.007,0.244,-0.004,0.970"
            ]
        },
        {
            "time": 1.815000057220459,
            "data": [
                "prisoner,1.079,0.600,4.169,0.000,0.998,0.000,0.059",
                "victimM,1.540,0.600,0.737,0.000,-1.000,0.000,0.023",
                "citizenF,-0.218,0.600,-3.306,0.000,0.712,0.000,0.702",
                "observationCamera,1.191,0.886,0.036,0.007,0.242,-0.004,0.970"
            ]
        },
        {
            "time": 1.8300000429153443,
            "data": [
                "prisoner,1.082,0.600,4.151,0.000,0.998,0.000,0.058",
                "victimM,1.532,0.600,0.725,0.000,-1.000,0.000,0.017",
                "citizenF,-0.218,0.600,-3.302,0.000,0.715,0.000,0.700",
                "observationCamera,1.188,0.887,0.029,0.007,0.240,-0.004,0.971"
            ]
        },
        {
            "time": 1.8459999561309815,
            "data": [
                "prisoner,1.085,0.600,4.134,0.000,0.998,0.000,0.058",
                "victimM,1.525,0.600,0.713,0.000,-1.000,0.000,0.012",
                "citizenF,-0.218,0.600,-3.299,0.000,0.717,0.000,0.697",
                "observationCamera,1.186,0.888,0.021,0.007,0.237,-0.004,0.971"
            ]
        },
        {
            "time": 1.8609999418258668,
            "data": [
                "prisoner,1.088,0.600,4.116,0.000,0.998,0.000,0.057",
                "victimM,1.519,0.600,0.701,0.000,-1.000,0.000,0.008",
                "citizenF,-0.218,0.600,-3.296,0.000,0.719,0.000,0.695",
                "observationCamera,1.184,0.889,0.014,0.007,0.235,-0.004,0.972"
            ]
        },
        {
            "time": 1.878999948501587,
            "data": [
                "prisoner,1.090,0.600,4.099,0.000,0.998,0.000,0.057",
                "victimM,1.513,0.600,0.689,0.000,-1.000,0.000,0.004",
                "citizenF,-0.218,0.600,-3.293,0.000,0.721,0.000,0.693",
                "observationCamera,1.182,0.891,0.007,0.006,0.232,-0.004,0.973"
            ]
        },
        {
            "time": 1.8949999809265137,
            "data": [
                "prisoner,1.094,0.600,4.078,0.000,0.998,0.000,0.057",
                "victimM,1.507,0.600,0.675,0.000,-1.000,0.000,0.000",
                "citizenF,-0.218,0.600,-3.290,0.000,0.722,0.000,0.691",
                "observationCamera,1.180,0.892,-0.001,0.006,0.230,-0.004,0.973"
            ]
        },
        {
            "time": 1.9079999923706055,
            "data": [
                "prisoner,1.096,0.600,4.059,0.000,0.998,0.000,0.056",
                "victimM,1.502,0.600,0.662,0.000,-1.000,0.000,-0.004",
                "citizenF,-0.219,0.600,-3.287,0.000,0.724,0.000,0.690",
                "observationCamera,1.178,0.893,-0.007,0.006,0.227,-0.004,0.974"
            ]
        },
        {
            "time": 1.9229999780654908,
            "data": [
                "prisoner,1.099,0.600,4.044,0.000,0.998,0.000,0.056",
                "victimM,1.499,0.600,0.652,0.000,-1.000,0.000,-0.006",
                "citizenF,-0.219,0.600,-3.286,0.000,0.725,0.000,0.689",
                "observationCamera,1.177,0.893,-0.013,0.006,0.225,-0.004,0.974"
            ]
        },
        {
            "time": 1.937999963760376,
            "data": [
                "prisoner,1.101,0.600,4.025,0.000,0.998,0.000,0.056",
                "victimM,1.495,0.600,0.639,0.000,-1.000,0.000,-0.009",
                "citizenF,-0.219,0.600,-3.284,0.000,0.726,0.000,0.688",
                "observationCamera,1.175,0.894,-0.019,0.006,0.223,-0.004,0.975"
            ]
        },
        {
            "time": 1.9539999961853028,
            "data": [
                "prisoner,1.104,0.600,4.006,0.000,0.998,0.000,0.056",
                "victimM,1.492,0.600,0.627,0.000,-1.000,0.000,-0.011",
                "citizenF,-0.219,0.600,-3.283,0.000,0.727,0.000,0.687",
                "observationCamera,1.174,0.895,-0.024,0.006,0.221,-0.004,0.975"
            ]
        },
        {
            "time": 1.968999981880188,
            "data": [
                "prisoner,1.107,0.600,3.987,0.000,0.998,0.000,0.055",
                "victimM,1.490,0.600,0.615,0.000,-1.000,0.000,-0.012",
                "citizenF,-0.219,0.600,-3.281,0.000,0.728,0.000,0.686",
                "observationCamera,1.174,0.895,-0.030,0.006,0.219,-0.004,0.976"
            ]
        },
        {
            "time": 1.9869999885559083,
            "data": [
                "prisoner,1.109,0.600,3.968,0.000,0.998,0.000,0.055",
                "victimM,1.488,0.600,0.602,0.000,-1.000,0.000,-0.014",
                "citizenF,-0.219,0.600,-3.281,0.000,0.728,0.000,0.685",
                "observationCamera,1.173,0.896,-0.035,0.006,0.216,-0.004,0.976"
            ]
        },
        {
            "time": 2.003000020980835,
            "data": [
                "prisoner,1.112,0.600,3.945,0.000,0.999,0.000,0.055",
                "victimM,1.487,0.600,0.588,0.000,-1.000,0.000,-0.014",
                "citizenF,-0.219,0.600,-3.280,0.000,0.728,0.000,0.685",
                "observationCamera,1.173,0.896,-0.041,0.006,0.214,-0.004,0.977"
            ]
        },
        {
            "time": 2.0160000324249269,
            "data": [
                "prisoner,1.115,0.600,3.925,0.000,0.999,0.000,0.054",
                "victimM,1.487,0.600,0.575,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.219,0.600,-3.280,0.000,0.729,0.000,0.685",
                "observationCamera,1.172,0.896,-0.046,0.006,0.212,-0.004,0.977"
            ]
        },
        {
            "time": 2.0309998989105226,
            "data": [
                "prisoner,1.117,0.600,3.908,0.000,0.999,0.000,0.054",
                "victimM,1.487,0.600,0.564,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.218,0.600,-3.280,0.000,0.728,0.000,0.685",
                "observationCamera,1.173,0.896,-0.050,0.006,0.210,-0.004,0.978"
            ]
        },
        {
            "time": 2.0460000038146974,
            "data": [
                "prisoner,1.119,0.600,3.888,0.000,0.999,0.000,0.054",
                "victimM,1.487,0.600,0.551,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.217,0.600,-3.280,0.000,0.728,0.000,0.686",
                "observationCamera,1.173,0.896,-0.055,0.006,0.208,-0.004,0.978"
            ]
        },
        {
            "time": 2.061000108718872,
            "data": [
                "prisoner,1.122,0.600,3.868,0.000,0.999,0.000,0.054",
                "victimM,1.487,0.600,0.538,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.216,0.600,-3.280,0.000,0.727,0.000,0.686",
                "observationCamera,1.173,0.897,-0.060,0.006,0.206,-0.004,0.979"
            ]
        },
        {
            "time": 2.0769999027252199,
            "data": [
                "prisoner,1.124,0.600,3.847,0.000,0.999,0.000,0.053",
                "victimM,1.487,0.600,0.525,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.214,0.600,-3.280,0.000,0.726,0.000,0.687",
                "observationCamera,1.173,0.897,-0.064,0.006,0.203,-0.004,0.979"
            ]
        },
        {
            "time": 2.0940001010894777,
            "data": [
                "prisoner,1.127,0.600,3.826,0.000,0.999,0.000,0.053",
                "victimM,1.487,0.600,0.512,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.211,0.600,-3.281,0.000,0.725,0.000,0.689",
                "observationCamera,1.173,0.897,-0.069,0.006,0.201,-0.004,0.980"
            ]
        },
        {
            "time": 2.109999895095825,
            "data": [
                "prisoner,1.130,0.600,3.802,0.000,0.999,0.000,0.053",
                "victimM,1.488,0.600,0.496,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.207,0.600,-3.281,0.000,0.724,0.000,0.690",
                "observationCamera,1.173,0.897,-0.074,0.006,0.198,-0.004,0.980"
            ]
        },
        {
            "time": 2.122999906539917,
            "data": [
                "prisoner,1.132,0.600,3.781,0.000,0.999,0.000,0.052",
                "victimM,1.488,0.600,0.483,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.203,0.600,-3.281,0.000,0.722,0.000,0.692",
                "observationCamera,1.173,0.897,-0.078,0.006,0.196,-0.004,0.981"
            ]
        },
        {
            "time": 2.1389999389648439,
            "data": [
                "prisoner,1.134,0.600,3.763,0.000,0.999,0.000,0.052",
                "victimM,1.488,0.600,0.471,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.199,0.600,-3.282,0.000,0.720,0.000,0.694",
                "observationCamera,1.174,0.897,-0.082,0.006,0.193,-0.004,0.981"
            ]
        },
        {
            "time": 2.1540000438690187,
            "data": [
                "prisoner,1.136,0.600,3.740,0.000,0.999,0.000,0.052",
                "victimM,1.488,0.600,0.456,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.194,0.600,-3.282,0.000,0.718,0.000,0.696",
                "observationCamera,1.174,0.897,-0.086,0.007,0.191,-0.004,0.982"
            ]
        },
        {
            "time": 2.1679999828338625,
            "data": [
                "prisoner,1.139,0.600,3.719,0.000,0.999,0.000,0.052",
                "victimM,1.488,0.600,0.443,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.189,0.600,-3.282,0.000,0.716,0.000,0.698",
                "observationCamera,1.174,0.897,-0.091,0.007,0.188,-0.004,0.982"
            ]
        },
        {
            "time": 2.183000087738037,
            "data": [
                "prisoner,1.141,0.600,3.698,0.000,0.999,0.000,0.052",
                "victimM,1.489,0.600,0.429,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.183,0.600,-3.283,0.000,0.713,0.000,0.701",
                "observationCamera,1.175,0.897,-0.094,0.007,0.186,-0.004,0.983"
            ]
        },
        {
            "time": 2.2009999752044679,
            "data": [
                "prisoner,1.143,0.600,3.676,0.000,0.999,0.000,0.051",
                "victimM,1.489,0.600,0.415,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.177,0.600,-3.283,0.000,0.710,0.000,0.704",
                "observationCamera,1.175,0.897,-0.098,0.007,0.183,-0.004,0.983"
            ]
        },
        {
            "time": 2.2160000801086427,
            "data": [
                "prisoner,1.146,0.600,3.651,0.000,0.999,0.000,0.051",
                "victimM,1.489,0.600,0.398,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.169,0.600,-3.284,0.000,0.707,0.000,0.707",
                "observationCamera,1.176,0.898,-0.103,0.007,0.180,-0.004,0.984"
            ]
        },
        {
            "time": 2.2290000915527345,
            "data": [
                "prisoner,1.148,0.600,3.628,0.000,0.999,0.000,0.051",
                "victimM,1.490,0.600,0.384,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.161,0.600,-3.285,0.000,0.704,0.000,0.710",
                "observationCamera,1.176,0.898,-0.107,0.008,0.177,-0.004,0.984"
            ]
        },
        {
            "time": 2.24399995803833,
            "data": [
                "prisoner,1.150,0.600,3.610,0.000,0.999,0.000,0.051",
                "victimM,1.490,0.600,0.372,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.155,0.600,-3.285,0.000,0.701,0.000,0.713",
                "observationCamera,1.176,0.898,-0.110,0.008,0.174,-0.004,0.985"
            ]
        },
        {
            "time": 2.259000062942505,
            "data": [
                "prisoner,1.152,0.600,3.587,0.000,0.999,0.000,0.050",
                "victimM,1.490,0.600,0.357,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.147,0.600,-3.286,0.000,0.698,0.000,0.716",
                "observationCamera,1.177,0.898,-0.113,0.008,0.172,-0.004,0.985"
            ]
        },
        {
            "time": 2.2750000953674318,
            "data": [
                "prisoner,1.154,0.600,3.564,0.000,0.999,0.000,0.050",
                "victimM,1.491,0.600,0.342,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.139,0.600,-3.286,0.000,0.694,0.000,0.720",
                "observationCamera,1.177,0.898,-0.117,0.008,0.169,-0.004,0.986"
            ]
        },
        {
            "time": 2.2899999618530275,
            "data": [
                "prisoner,1.157,0.600,3.540,0.000,0.999,0.000,0.050",
                "victimM,1.491,0.600,0.327,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.129,0.600,-3.287,0.000,0.690,0.000,0.724",
                "observationCamera,1.178,0.898,-0.121,0.008,0.166,-0.004,0.986"
            ]
        },
        {
            "time": 2.308000087738037,
            "data": [
                "prisoner,1.159,0.600,3.517,0.000,0.999,0.000,0.050",
                "victimM,1.492,0.600,0.312,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.120,0.600,-3.288,0.000,0.686,0.000,0.728",
                "observationCamera,1.179,0.898,-0.124,0.009,0.163,-0.004,0.987"
            ]
        },
        {
            "time": 2.325000047683716,
            "data": [
                "prisoner,1.161,0.600,3.490,0.000,0.999,0.000,0.050",
                "victimM,1.492,0.600,0.294,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.109,0.600,-3.289,0.000,0.681,0.000,0.732",
                "observationCamera,1.179,0.898,-0.128,0.009,0.159,-0.004,0.987"
            ]
        },
        {
            "time": 2.3369998931884767,
            "data": [
                "prisoner,1.164,0.600,3.463,0.000,0.999,0.000,0.049",
                "victimM,1.493,0.600,0.276,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.098,0.600,-3.289,0.000,0.676,0.000,0.737",
                "observationCamera,1.180,0.898,-0.132,0.009,0.156,-0.004,0.988"
            ]
        },
        {
            "time": 2.3529999256134035,
            "data": [
                "prisoner,1.165,0.600,3.443,0.000,0.999,0.000,0.049",
                "victimM,1.493,0.600,0.264,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.090,0.600,-3.290,0.000,0.672,0.000,0.740",
                "observationCamera,1.180,0.898,-0.135,0.009,0.153,-0.004,0.988"
            ]
        },
        {
            "time": 2.36899995803833,
            "data": [
                "prisoner,1.168,0.600,3.420,0.000,0.999,0.000,0.049",
                "victimM,1.494,0.600,0.249,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.079,0.600,-3.291,0.000,0.667,0.000,0.745",
                "observationCamera,1.181,0.898,-0.138,0.010,0.150,-0.004,0.989"
            ]
        },
        {
            "time": 2.385999917984009,
            "data": [
                "prisoner,1.170,0.600,3.394,0.000,0.999,0.000,0.049",
                "victimM,1.494,0.600,0.233,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.068,0.600,-3.292,0.000,0.662,0.000,0.749",
                "observationCamera,1.182,0.898,-0.141,0.010,0.147,-0.004,0.989"
            ]
        },
        {
            "time": 2.4010000228881838,
            "data": [
                "prisoner,1.172,0.600,3.367,0.000,0.999,0.000,0.049",
                "victimM,1.495,0.600,0.215,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.056,0.600,-3.293,0.000,0.657,0.000,0.754",
                "observationCamera,1.182,0.898,-0.144,0.010,0.144,-0.004,0.990"
            ]
        },
        {
            "time": 2.4200000762939455,
            "data": [
                "prisoner,1.174,0.600,3.343,0.000,0.999,0.000,0.048",
                "victimM,1.495,0.600,0.200,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.045,0.600,-3.293,0.000,0.652,0.000,0.758",
                "observationCamera,1.183,0.899,-0.147,0.011,0.141,-0.003,0.990"
            ]
        },
        {
            "time": 2.434000015258789,
            "data": [
                "prisoner,1.177,0.600,3.313,0.000,0.999,0.000,0.048",
                "victimM,1.496,0.600,0.180,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.031,0.600,-3.294,0.000,0.645,0.000,0.764",
                "observationCamera,1.184,0.899,-0.151,0.011,0.137,-0.003,0.990"
            ]
        },
        {
            "time": 2.4489998817443849,
            "data": [
                "prisoner,1.179,0.600,3.289,0.000,0.999,0.000,0.048",
                "victimM,1.497,0.600,0.165,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.019,0.600,-3.295,0.000,0.640,0.000,0.768",
                "observationCamera,1.184,0.899,-0.153,0.011,0.134,-0.003,0.991"
            ]
        },
        {
            "time": 2.4670000076293947,
            "data": [
                "prisoner,1.181,0.600,3.265,0.000,0.999,0.000,0.048",
                "victimM,1.497,0.600,0.150,0.000,-1.000,0.000,-0.015",
                "citizenF,-0.008,0.600,-3.296,0.000,0.635,0.000,0.773",
                "observationCamera,1.185,0.899,-0.156,0.012,0.132,-0.003,0.991"
            ]
        },
        {
            "time": 2.4809999465942385,
            "data": [
                "prisoner,1.183,0.600,3.236,0.000,0.999,0.000,0.048",
                "victimM,1.498,0.600,0.131,0.000,-1.000,0.000,-0.015",
                "citizenF,0.006,0.600,-3.297,0.000,0.628,0.000,0.778",
                "observationCamera,1.186,0.899,-0.159,0.012,0.128,-0.003,0.992"
            ]
        },
        {
            "time": 2.499000072479248,
            "data": [
                "prisoner,1.185,0.600,3.212,0.000,0.999,0.000,0.047",
                "victimM,1.498,0.600,0.117,0.000,-1.000,0.000,-0.015",
                "citizenF,0.018,0.600,-3.298,0.000,0.623,0.000,0.782",
                "observationCamera,1.187,0.899,-0.162,0.012,0.126,-0.003,0.992"
            ]
        },
        {
            "time": 2.515000104904175,
            "data": [
                "prisoner,1.187,0.600,3.182,0.000,0.999,0.000,0.047",
                "victimM,1.499,0.600,0.098,0.000,-1.000,0.000,-0.015",
                "citizenF,0.032,0.600,-3.299,0.000,0.616,0.000,0.787",
                "observationCamera,1.187,0.899,-0.164,0.013,0.122,-0.003,0.992"
            ]
        },
        {
            "time": 2.5329999923706056,
            "data": [
                "prisoner,1.189,0.600,3.155,0.000,0.999,0.000,0.047",
                "victimM,1.500,0.600,0.081,0.000,-1.000,0.000,-0.015",
                "citizenF,0.045,0.600,-3.300,0.000,0.610,0.000,0.792",
                "observationCamera,1.188,0.899,-0.167,0.013,0.119,-0.003,0.993"
            ]
        },
        {
            "time": 2.546999931335449,
            "data": [
                "prisoner,1.192,0.600,3.124,0.000,0.999,0.000,0.047",
                "victimM,1.500,0.600,0.062,0.000,-1.000,0.000,-0.015",
                "citizenF,0.060,0.600,-3.301,0.000,0.603,0.000,0.798",
                "observationCamera,1.189,0.899,-0.170,0.013,0.116,-0.003,0.993"
            ]
        },
        {
            "time": 2.563999891281128,
            "data": [
                "prisoner,1.194,0.600,3.101,0.000,0.999,0.000,0.047",
                "victimM,1.501,0.600,0.047,0.000,-1.000,0.000,-0.015",
                "citizenF,0.072,0.600,-3.302,0.000,0.598,0.000,0.802",
                "observationCamera,1.190,0.899,-0.172,0.014,0.113,-0.003,0.993"
            ]
        },
        {
            "time": 2.5799999237060549,
            "data": [
                "prisoner,1.196,0.600,3.073,0.000,0.999,0.000,0.047",
                "victimM,1.501,0.600,0.030,0.000,-1.000,0.000,-0.015",
                "citizenF,0.085,0.600,-3.303,0.000,0.592,0.000,0.806",
                "observationCamera,1.190,0.899,-0.174,0.014,0.110,-0.003,0.994"
            ]
        },
        {
            "time": 2.5950000286102297,
            "data": [
                "prisoner,1.198,0.600,3.045,0.000,0.999,0.000,0.046",
                "victimM,1.502,0.600,0.013,0.000,-1.000,0.000,-0.015",
                "citizenF,0.099,0.600,-3.304,0.000,0.585,0.000,0.811",
                "observationCamera,1.191,0.899,-0.176,0.014,0.107,-0.003,0.994"
            ]
        },
        {
            "time": 2.61299991607666,
            "data": [
                "prisoner,1.200,0.600,3.019,0.000,0.999,0.000,0.046",
                "victimM,1.503,0.600,-0.003,0.000,-1.000,0.000,-0.015",
                "citizenF,0.112,0.600,-3.304,0.000,0.579,0.000,0.815",
                "observationCamera,1.192,0.899,-0.178,0.014,0.105,-0.003,0.994"
            ]
        },
        {
            "time": 2.627000093460083,
            "data": [
                "prisoner,1.202,0.600,2.989,0.000,0.999,0.000,0.046",
                "victimM,1.503,0.600,-0.021,0.000,-1.000,0.000,-0.015",
                "citizenF,0.126,0.600,-3.305,0.000,0.572,0.000,0.820",
                "observationCamera,1.192,0.899,-0.180,0.015,0.102,-0.003,0.995"
            ]
        },
        {
            "time": 2.6470000743865969,
            "data": [
                "prisoner,1.204,0.600,2.964,0.000,0.999,0.000,0.046",
                "victimM,1.504,0.600,-0.037,0.000,-1.000,0.000,-0.015",
                "citizenF,0.138,0.600,-3.306,0.000,0.566,0.000,0.824",
                "observationCamera,1.193,0.899,-0.182,0.015,0.099,-0.003,0.995"
            ]
        },
        {
            "time": 2.6610000133514406,
            "data": [
                "prisoner,1.206,0.600,2.930,0.000,0.999,0.000,0.046",
                "victimM,1.505,0.600,-0.057,0.000,-1.000,0.000,-0.015",
                "citizenF,0.154,0.600,-3.307,0.000,0.559,0.000,0.829",
                "observationCamera,1.194,0.899,-0.184,0.015,0.096,-0.003,0.995"
            ]
        },
        {
            "time": 2.677999973297119,
            "data": [
                "prisoner,1.208,0.600,2.905,0.000,0.999,0.000,0.046",
                "victimM,1.505,0.600,-0.072,0.000,-1.000,0.000,-0.015",
                "citizenF,0.166,0.600,-3.308,0.000,0.553,0.000,0.833",
                "observationCamera,1.194,0.899,-0.186,0.016,0.094,-0.003,0.995"
            ]
        },
        {
            "time": 2.694000005722046,
            "data": [
                "prisoner,1.210,0.600,2.876,0.000,0.999,0.000,0.046",
                "victimM,1.506,0.600,-0.089,0.000,-1.000,0.000,-0.015",
                "citizenF,0.180,0.600,-3.309,0.000,0.547,0.000,0.837",
                "observationCamera,1.195,0.899,-0.188,0.016,0.092,-0.002,0.996"
            ]
        },
        {
            "time": 2.7090001106262209,
            "data": [
                "prisoner,1.212,0.600,2.847,0.000,0.999,0.000,0.045",
                "victimM,1.507,0.600,-0.107,0.000,-1.000,0.000,-0.015",
                "citizenF,0.193,0.600,-3.310,0.000,0.540,0.000,0.841",
                "observationCamera,1.196,0.899,-0.189,0.016,0.089,-0.002,0.996"
            ]
        },
        {
            "time": 2.7269999980926515,
            "data": [
                "prisoner,1.214,0.600,2.821,0.000,0.999,0.000,0.045",
                "victimM,1.507,0.600,-0.122,0.000,-1.000,0.000,-0.015",
                "citizenF,0.205,0.600,-3.310,0.000,0.535,0.000,0.845",
                "observationCamera,1.196,0.899,-0.191,0.016,0.087,-0.002,0.996"
            ]
        },
        {
            "time": 2.743000030517578,
            "data": [
                "prisoner,1.216,0.600,2.789,0.000,0.999,0.000,0.045",
                "victimM,1.508,0.600,-0.141,0.000,-1.000,0.000,-0.015",
                "citizenF,0.219,0.600,-3.311,0.000,0.528,0.000,0.849",
                "observationCamera,1.197,0.900,-0.192,0.017,0.085,-0.002,0.996"
            ]
        },
        {
            "time": 2.763000011444092,
            "data": [
                "prisoner,1.218,0.600,2.761,0.000,0.999,0.000,0.045",
                "victimM,1.508,0.600,-0.158,0.000,-1.000,0.000,-0.015",
                "citizenF,0.232,0.600,-3.312,0.000,0.522,0.000,0.853",
                "observationCamera,1.197,0.900,-0.194,0.017,0.083,-0.002,0.996"
            ]
        },
        {
            "time": 2.7750000953674318,
            "data": [
                "prisoner,1.220,0.600,2.725,0.000,0.999,0.000,0.045",
                "victimM,1.509,0.600,-0.178,0.000,-1.000,0.000,-0.015",
                "citizenF,0.247,0.600,-3.313,0.000,0.515,0.000,0.857",
                "observationCamera,1.198,0.900,-0.195,0.017,0.080,-0.002,0.997"
            ]
        },
        {
            "time": 2.7920000553131105,
            "data": [
                "prisoner,1.222,0.600,2.703,0.000,0.999,0.000,0.045",
                "victimM,1.510,0.600,-0.191,0.000,-1.000,0.000,-0.015",
                "citizenF,0.257,0.600,-3.313,0.000,0.510,0.000,0.860",
                "observationCamera,1.199,0.900,-0.196,0.017,0.079,-0.002,0.997"
            ]
        },
        {
            "time": 2.808000087738037,
            "data": [
                "prisoner,1.224,0.600,2.673,0.000,0.999,0.000,0.045",
                "victimM,1.510,0.600,-0.208,0.000,-1.000,0.000,-0.015",
                "citizenF,0.270,0.600,-3.314,0.000,0.504,0.000,0.863",
                "observationCamera,1.199,0.900,-0.197,0.018,0.077,-0.002,0.997"
            ]
        },
        {
            "time": 2.822999954223633,
            "data": [
                "prisoner,1.226,0.600,2.643,0.000,0.999,0.000,0.045",
                "victimM,1.511,0.600,-0.225,0.000,-1.000,0.000,-0.015",
                "citizenF,0.281,0.600,-3.314,0.000,0.499,0.000,0.867",
                "observationCamera,1.199,0.900,-0.198,0.018,0.075,-0.002,0.997"
            ]
        },
        {
            "time": 2.8399999141693117,
            "data": [
                "prisoner,1.228,0.600,2.616,0.000,0.999,0.000,0.045",
                "victimM,1.511,0.600,-0.240,0.000,-1.000,0.000,-0.015",
                "citizenF,0.292,0.600,-3.315,0.000,0.494,0.000,0.869",
                "observationCamera,1.200,0.900,-0.199,0.018,0.074,-0.002,0.997"
            ]
        },
        {
            "time": 2.8580000400543215,
            "data": [
                "prisoner,1.230,0.600,2.587,0.000,0.999,0.000,0.044",
                "victimM,1.512,0.600,-0.256,0.000,-1.000,0.000,-0.015",
                "citizenF,0.304,0.600,-3.315,0.000,0.489,0.000,0.872",
                "observationCamera,1.200,0.900,-0.200,0.018,0.072,-0.002,0.997"
            ]
        },
        {
            "time": 2.877000093460083,
            "data": [
                "prisoner,1.232,0.600,2.554,0.000,0.999,0.000,0.044",
                "victimM,1.512,0.600,-0.274,0.000,-1.000,0.000,-0.015",
                "citizenF,0.316,0.600,-3.316,0.000,0.483,0.000,0.875",
                "observationCamera,1.201,0.900,-0.201,0.018,0.071,-0.002,0.997"
            ]
        },
        {
            "time": 2.8940000534057619,
            "data": [
                "prisoner,1.234,0.600,2.519,0.000,0.999,0.000,0.044",
                "victimM,1.513,0.600,-0.293,0.000,-1.000,0.000,-0.015",
                "citizenF,0.328,0.600,-3.316,0.000,0.478,0.000,0.879",
                "observationCamera,1.201,0.900,-0.202,0.019,0.069,-0.002,0.997"
            ]
        },
        {
            "time": 2.9059998989105226,
            "data": [
                "prisoner,1.236,0.600,2.487,0.000,0.999,0.000,0.044",
                "victimM,1.513,0.600,-0.311,0.000,-1.000,0.000,-0.015",
                "citizenF,0.340,0.600,-3.317,0.000,0.473,0.000,0.881",
                "observationCamera,1.201,0.900,-0.203,0.019,0.068,-0.002,0.997"
            ]
        },
        {
            "time": 2.921999931335449,
            "data": [
                "prisoner,1.238,0.600,2.466,0.000,0.999,0.000,0.044",
                "victimM,1.514,0.600,-0.322,0.000,-1.000,0.000,-0.015",
                "citizenF,0.347,0.600,-3.317,0.000,0.470,0.000,0.883",
                "observationCamera,1.202,0.900,-0.203,0.019,0.068,-0.002,0.998"
            ]
        },
        {
            "time": 2.940000057220459,
            "data": [
                "prisoner,1.240,0.600,2.436,0.000,0.999,0.000,0.044",
                "victimM,1.514,0.600,-0.338,0.000,-1.000,0.000,-0.015",
                "citizenF,0.357,0.600,-3.317,0.000,0.465,0.000,0.885",
                "observationCamera,1.202,0.900,-0.203,0.019,0.067,-0.002,0.998"
            ]
        },
        {
            "time": 2.9549999237060549,
            "data": [
                "prisoner,1.242,0.600,2.402,0.000,0.999,0.000,0.044",
                "victimM,1.515,0.600,-0.356,0.000,-1.000,0.000,-0.015",
                "citizenF,0.367,0.600,-3.318,0.000,0.461,0.000,0.887",
                "observationCamera,1.202,0.900,-0.204,0.019,0.066,-0.002,0.998"
            ]
        },
        {
            "time": 2.9719998836517336,
            "data": [
                "prisoner,1.244,0.600,2.375,0.000,0.999,0.000,0.044",
                "victimM,1.515,0.600,-0.370,0.000,-1.000,0.000,-0.015",
                "citizenF,0.375,0.600,-3.318,0.000,0.458,0.000,0.889",
                "observationCamera,1.202,0.900,-0.204,0.019,0.066,-0.002,0.998"
            ]
        },
        {
            "time": 2.990999937057495,
            "data": [
                "prisoner,1.246,0.600,2.344,0.000,0.999,0.000,0.044",
                "victimM,1.515,0.600,-0.386,0.000,-1.000,0.000,-0.015",
                "citizenF,0.383,0.600,-3.318,0.000,0.455,0.000,0.891",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.00600004196167,
            "data": [
                "prisoner,1.248,0.600,2.309,0.000,0.999,0.000,0.044",
                "victimM,1.516,0.600,-0.404,0.000,-1.000,0.000,-0.015",
                "citizenF,0.393,0.600,-3.318,0.000,0.451,0.000,0.893",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.0209999084472658,
            "data": [
                "prisoner,1.250,0.600,2.280,0.000,0.999,0.000,0.044",
                "victimM,1.516,0.600,-0.419,0.000,-1.000,0.000,-0.015",
                "citizenF,0.400,0.600,-3.318,0.000,0.448,0.000,0.894",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.0390000343322756,
            "data": [
                "prisoner,1.252,0.600,2.252,0.000,0.999,0.000,0.043",
                "victimM,1.516,0.600,-0.433,0.000,-1.000,0.000,-0.015",
                "citizenF,0.407,0.600,-3.318,0.000,0.446,0.000,0.895",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.055999994277954,
            "data": [
                "prisoner,1.254,0.600,2.219,0.000,0.999,0.000,0.043",
                "victimM,1.517,0.600,-0.449,0.000,-1.000,0.000,-0.015",
                "citizenF,0.415,0.600,-3.317,0.000,0.443,0.000,0.896",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.071000099182129,
            "data": [
                "prisoner,1.256,0.600,2.187,0.000,0.999,0.000,0.043",
                "victimM,1.517,0.600,-0.464,0.000,-1.000,0.000,-0.015",
                "citizenF,0.423,0.600,-3.317,0.000,0.441,0.000,0.898",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.0869998931884767,
            "data": [
                "prisoner,1.258,0.600,2.160,0.000,0.999,0.000,0.043",
                "victimM,1.517,0.600,-0.478,0.000,-1.000,0.000,-0.014",
                "citizenF,0.429,0.600,-3.316,0.000,0.438,0.000,0.899",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.1059999465942385,
            "data": [
                "prisoner,1.260,0.600,2.129,0.000,0.999,0.000,0.043",
                "victimM,1.517,0.600,-0.493,0.000,-1.000,0.000,-0.014",
                "citizenF,0.437,0.600,-3.315,0.000,0.436,0.000,0.900",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.124000072479248,
            "data": [
                "prisoner,1.262,0.600,2.093,0.000,0.999,0.000,0.043",
                "victimM,1.518,0.600,-0.510,0.000,-1.000,0.000,-0.014",
                "citizenF,0.446,0.600,-3.314,0.000,0.433,0.000,0.902",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.13700008392334,
            "data": [
                "prisoner,1.264,0.600,2.060,0.000,0.999,0.000,0.043",
                "victimM,1.518,0.600,-0.526,0.000,-1.000,0.000,-0.013",
                "citizenF,0.454,0.600,-3.312,0.000,0.430,0.000,0.903",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.1549999713897707,
            "data": [
                "prisoner,1.266,0.600,2.035,0.000,0.999,0.000,0.043",
                "victimM,1.518,0.600,-0.538,0.000,-1.000,0.000,-0.012",
                "citizenF,0.460,0.600,-3.311,0.000,0.428,0.000,0.904",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.171999931335449,
            "data": [
                "prisoner,1.268,0.600,2.002,0.000,0.999,0.000,0.043",
                "victimM,1.518,0.600,-0.555,0.000,-1.000,0.000,-0.012",
                "citizenF,0.469,0.600,-3.309,0.000,0.425,0.000,0.905",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.188999891281128,
            "data": [
                "prisoner,1.270,0.600,1.970,0.000,0.999,0.000,0.043",
                "victimM,1.519,0.600,-0.570,0.000,-1.000,0.000,-0.011",
                "citizenF,0.477,0.600,-3.307,0.000,0.423,0.000,0.906",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.2079999446868898,
            "data": [
                "prisoner,1.272,0.600,1.939,0.000,0.999,0.000,0.043",
                "victimM,1.519,0.600,-0.585,0.000,-1.000,0.000,-0.010",
                "citizenF,0.485,0.600,-3.304,0.000,0.420,0.000,0.907",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.2230000495910646,
            "data": [
                "prisoner,1.274,0.600,1.902,0.000,0.999,0.000,0.043",
                "victimM,1.519,0.600,-0.603,0.000,-1.000,0.000,-0.009",
                "citizenF,0.494,0.600,-3.302,0.000,0.417,0.000,0.909",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.23799991607666,
            "data": [
                "prisoner,1.276,0.600,1.874,0.000,0.999,0.000,0.043",
                "victimM,1.519,0.600,-0.616,0.000,-1.000,0.000,-0.008",
                "citizenF,0.501,0.600,-3.299,0.000,0.415,0.000,0.910",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.253000020980835,
            "data": [
                "prisoner,1.278,0.600,1.846,0.000,0.999,0.000,0.043",
                "victimM,1.520,0.600,-0.630,0.000,-1.000,0.000,-0.007",
                "citizenF,0.509,0.600,-3.297,0.000,0.413,0.000,0.911",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.2699999809265138,
            "data": [
                "prisoner,1.280,0.600,1.817,0.000,0.999,0.000,0.043",
                "victimM,1.520,0.600,-0.644,0.000,-1.000,0.000,-0.006",
                "citizenF,0.516,0.600,-3.294,0.000,0.411,0.000,0.912",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.2860000133514406,
            "data": [
                "prisoner,1.282,0.600,1.786,0.000,0.999,0.000,0.043",
                "victimM,1.520,0.600,-0.659,0.000,-1.000,0.000,-0.005",
                "citizenF,0.524,0.600,-3.291,0.000,0.408,0.000,0.913",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.303999900817871,
            "data": [
                "prisoner,1.284,0.600,1.755,0.000,0.999,0.000,0.043",
                "victimM,1.520,0.600,-0.674,0.000,-1.000,0.000,-0.003",
                "citizenF,0.532,0.600,-3.288,0.000,0.406,0.000,0.914",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.3239998817443849,
            "data": [
                "prisoner,1.286,0.600,1.722,0.000,0.999,0.000,0.043",
                "victimM,1.521,0.600,-0.690,0.000,-1.000,0.000,-0.002",
                "citizenF,0.541,0.600,-3.284,0.000,0.403,0.000,0.915",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.3380000591278078,
            "data": [
                "prisoner,1.289,0.600,1.684,0.000,0.999,0.000,0.043",
                "victimM,1.521,0.600,-0.708,0.000,-1.000,0.000,0.000",
                "citizenF,0.551,0.600,-3.280,0.000,0.400,0.000,0.916",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.3519999980926515,
            "data": [
                "prisoner,1.290,0.600,1.658,0.000,0.999,0.000,0.042",
                "victimM,1.521,0.600,-0.721,0.000,-1.000,0.000,0.001",
                "citizenF,0.558,0.600,-3.277,0.000,0.399,0.000,0.917",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.369999885559082,
            "data": [
                "prisoner,1.292,0.600,1.630,0.000,0.999,0.000,0.042",
                "victimM,1.521,0.600,-0.735,0.000,-1.000,0.000,0.002",
                "citizenF,0.565,0.600,-3.273,0.000,0.396,0.000,0.918",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.385999917984009,
            "data": [
                "prisoner,1.295,0.600,1.597,0.000,0.999,0.000,0.042",
                "victimM,1.522,0.600,-0.751,0.000,-1.000,0.000,0.004",
                "citizenF,0.574,0.600,-3.269,0.000,0.394,0.000,0.919",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.4019999504089357,
            "data": [
                "prisoner,1.297,0.600,1.566,0.000,0.999,0.000,0.042",
                "victimM,1.522,0.600,-0.766,0.000,-1.000,0.000,0.005",
                "citizenF,0.582,0.600,-3.265,0.000,0.392,0.000,0.920",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.4179999828338625,
            "data": [
                "prisoner,1.299,0.600,1.538,0.000,0.999,0.000,0.042",
                "victimM,1.522,0.600,-0.779,0.000,-1.000,0.000,0.007",
                "citizenF,0.589,0.600,-3.261,0.000,0.390,0.000,0.921",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.438999891281128,
            "data": [
                "prisoner,1.301,0.600,1.507,0.000,0.999,0.000,0.042",
                "victimM,1.522,0.600,-0.794,0.000,-1.000,0.000,0.009",
                "citizenF,0.597,0.600,-3.257,0.000,0.387,0.000,0.922",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.453000068664551,
            "data": [
                "prisoner,1.304,0.600,1.468,0.000,0.999,0.000,0.042",
                "victimM,1.523,0.600,-0.813,0.000,-1.000,0.000,0.011",
                "citizenF,0.608,0.600,-3.251,0.000,0.385,0.000,0.923",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.4670000076293947,
            "data": [
                "prisoner,1.305,0.600,1.442,0.000,0.999,0.000,0.042",
                "victimM,1.523,0.600,-0.826,0.000,-1.000,0.000,0.013",
                "citizenF,0.615,0.600,-3.247,0.000,0.383,0.000,0.924",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.484999895095825,
            "data": [
                "prisoner,1.307,0.600,1.415,0.000,0.999,0.000,0.042",
                "victimM,1.523,0.600,-0.839,0.000,-1.000,0.000,0.014",
                "citizenF,0.622,0.600,-3.243,0.000,0.381,0.000,0.925",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.502000093460083,
            "data": [
                "prisoner,1.310,0.600,1.381,0.000,0.999,0.000,0.042",
                "victimM,1.524,0.600,-0.856,0.000,-1.000,0.000,0.016",
                "citizenF,0.631,0.600,-3.237,0.000,0.378,0.000,0.926",
                "observationCamera,1.202,0.900,-0.204,0.019,0.065,-0.002,0.998"
            ]
        },
        {
            "time": 3.5169999599456789,
            "data": [
                "prisoner,1.312,0.600,1.351,0.000,0.999,0.000,0.042",
                "victimM,1.524,0.600,-0.871,0.000,-1.000,0.000,0.018",
                "citizenF,0.639,0.600,-3.232,0.000,0.376,0.000,0.927",
                "observationCamera,1.219,0.899,-0.271,0.019,0.062,-0.002,0.998"
            ]
        },
        {
            "time": 3.5329999923706056,
            "data": [
                "prisoner,1.314,0.600,1.322,0.000,0.999,0.000,0.042",
                "victimM,1.524,0.600,-0.884,0.000,-1.000,0.000,0.020",
                "citizenF,0.647,0.600,-3.228,0.000,0.374,0.000,0.927",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 3.553999900817871,
            "data": [
                "prisoner,1.316,0.600,1.292,0.000,0.999,0.000,0.042",
                "victimM,1.524,0.600,-0.899,0.000,-1.000,0.000,0.022",
                "citizenF,0.655,0.600,-3.222,0.000,0.372,0.000,0.928",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 3.569999933242798,
            "data": [
                "prisoner,1.319,0.600,1.253,0.000,0.999,0.000,0.042",
                "victimM,1.525,0.600,-0.918,0.000,-1.000,0.000,0.025",
                "citizenF,0.665,0.600,-3.216,0.000,0.370,0.000,0.929",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 3.5840001106262209,
            "data": [
                "prisoner,1.321,0.600,1.224,0.000,0.999,0.000,0.042",
                "victimM,1.525,0.600,-0.933,0.000,-1.000,0.000,0.027",
                "citizenF,0.673,0.600,-3.211,0.000,0.368,0.000,0.930",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 3.6019999980926515,
            "data": [
                "prisoner,1.323,0.600,1.197,0.000,0.999,0.000,0.042",
                "victimM,1.525,0.600,-0.946,0.000,-1.000,0.000,0.029",
                "citizenF,0.680,0.600,-3.206,0.000,0.366,0.000,0.931",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 3.621000051498413,
            "data": [
                "prisoner,1.326,0.600,1.164,0.000,0.999,0.000,0.042",
                "victimM,1.525,0.600,-0.963,0.000,-1.000,0.000,0.031",
                "citizenF,0.689,0.600,-3.200,0.000,0.364,0.000,0.932",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 3.638000011444092,
            "data": [
                "prisoner,1.328,0.600,1.130,0.000,0.999,0.000,0.042",
                "victimM,1.526,0.600,-0.979,0.000,-0.999,0.000,0.033",
                "citizenF,0.698,0.600,-3.193,0.000,0.361,0.000,0.932",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 3.6559998989105226,
            "data": [
                "prisoner,1.331,0.600,1.099,0.000,0.999,0.000,0.042",
                "victimM,1.526,0.600,-0.995,0.000,-0.999,0.000,0.036",
                "citizenF,0.706,0.600,-3.187,0.000,0.359,0.000,0.933",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 3.6740000247955324,
            "data": [
                "prisoner,1.333,0.600,1.066,0.000,0.999,0.000,0.042",
                "victimM,1.526,0.600,-1.011,0.000,-0.999,0.000,0.038",
                "citizenF,0.715,0.600,-3.181,0.000,0.357,0.000,0.934",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 3.688999891281128,
            "data": [
                "prisoner,1.336,0.600,1.032,0.000,0.999,0.000,0.042",
                "victimM,1.526,0.600,-1.028,0.000,-0.999,0.000,0.041",
                "citizenF,0.724,0.600,-3.174,0.000,0.355,0.000,0.935",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 3.7060000896453859,
            "data": [
                "prisoner,1.338,0.600,1.006,0.000,0.999,0.000,0.042",
                "victimM,1.527,0.600,-1.041,0.000,-0.999,0.000,0.043",
                "citizenF,0.731,0.600,-3.169,0.000,0.353,0.000,0.936",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 3.7230000495910646,
            "data": [
                "prisoner,1.341,0.600,0.973,0.000,0.999,0.000,0.042",
                "victimM,1.527,0.600,-1.058,0.000,-0.999,0.000,0.046",
                "citizenF,0.740,0.600,-3.162,0.000,0.351,0.000,0.936",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 3.740999937057495,
            "data": [
                "prisoner,1.343,0.600,0.943,0.000,0.999,0.000,0.042",
                "victimM,1.527,0.600,-1.073,0.000,-0.999,0.000,0.048",
                "citizenF,0.748,0.600,-3.156,0.000,0.349,0.000,0.937",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 3.76200008392334,
            "data": [
                "prisoner,1.346,0.600,0.911,0.000,0.999,0.000,0.042",
                "victimM,1.527,0.600,-1.089,0.000,-0.999,0.000,0.051",
                "citizenF,0.757,0.600,-3.149,0.000,0.347,0.000,0.938",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 3.7780001163482668,
            "data": [
                "prisoner,1.349,0.600,0.873,0.000,0.999,0.000,0.042",
                "victimM,1.528,0.600,-1.108,0.000,-0.999,0.000,0.054",
                "citizenF,0.767,0.600,-3.141,0.000,0.345,0.000,0.939",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 3.7920000553131105,
            "data": [
                "prisoner,1.352,0.600,0.844,0.000,0.999,0.000,0.042",
                "victimM,1.528,0.600,-1.123,0.000,-0.998,0.000,0.056",
                "citizenF,0.774,0.600,-3.135,0.000,0.343,0.000,0.939",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 3.811000108718872,
            "data": [
                "prisoner,1.354,0.600,0.818,0.000,0.999,0.000,0.042",
                "victimM,1.528,0.600,-1.136,0.000,-0.998,0.000,0.059",
                "citizenF,0.781,0.600,-3.129,0.000,0.342,0.000,0.940",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 3.8269999027252199,
            "data": [
                "prisoner,1.357,0.600,0.786,0.000,0.999,0.000,0.042",
                "victimM,1.529,0.600,-1.153,0.000,-0.998,0.000,0.061",
                "citizenF,0.790,0.600,-3.122,0.000,0.340,0.000,0.941",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 3.8450000286102297,
            "data": [
                "prisoner,1.359,0.600,0.756,0.000,0.999,0.000,0.042",
                "victimM,1.529,0.600,-1.168,0.000,-0.998,0.000,0.064",
                "citizenF,0.798,0.600,-3.115,0.000,0.338,0.000,0.941",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 3.865999937057495,
            "data": [
                "prisoner,1.362,0.600,0.725,0.000,0.999,0.000,0.042",
                "victimM,1.529,0.600,-1.184,0.000,-0.998,0.000,0.067",
                "citizenF,0.806,0.600,-3.108,0.000,0.336,0.000,0.942",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 3.88100004196167,
            "data": [
                "prisoner,1.365,0.600,0.688,0.000,0.999,0.000,0.042",
                "victimM,1.529,0.600,-1.203,0.000,-0.998,0.000,0.070",
                "citizenF,0.816,0.600,-3.100,0.000,0.334,0.000,0.943",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 3.8970000743865969,
            "data": [
                "prisoner,1.368,0.600,0.662,0.000,0.999,0.000,0.042",
                "victimM,1.530,0.600,-1.217,0.000,-0.997,0.000,0.072",
                "citizenF,0.823,0.600,-3.094,0.000,0.332,0.000,0.943",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 3.9140000343322756,
            "data": [
                "prisoner,1.371,0.600,0.633,0.000,0.999,0.000,0.042",
                "victimM,1.530,0.600,-1.232,0.000,-0.997,0.000,0.075",
                "citizenF,0.830,0.600,-3.087,0.000,0.331,0.000,0.944",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 3.931999921798706,
            "data": [
                "prisoner,1.373,0.600,0.604,0.000,0.999,0.000,0.042",
                "victimM,1.530,0.600,-1.247,0.000,-0.997,0.000,0.078",
                "citizenF,0.838,0.600,-3.080,0.000,0.329,0.000,0.944",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 3.9489998817443849,
            "data": [
                "prisoner,1.376,0.600,0.574,0.000,0.999,0.000,0.042",
                "victimM,1.530,0.600,-1.263,0.000,-0.997,0.000,0.080",
                "citizenF,0.846,0.600,-3.073,0.000,0.327,0.000,0.945",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 3.9670000076293947,
            "data": [
                "prisoner,1.379,0.600,0.543,0.000,0.999,0.000,0.042",
                "victimM,1.531,0.600,-1.279,0.000,-0.997,0.000,0.083",
                "citizenF,0.854,0.600,-3.066,0.000,0.325,0.000,0.946",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 3.986999988555908,
            "data": [
                "prisoner,1.382,0.600,0.513,0.000,0.999,0.000,0.042",
                "victimM,1.531,0.600,-1.296,0.000,-0.996,0.000,0.086",
                "citizenF,0.862,0.600,-3.059,0.000,0.324,0.000,0.946",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 3.999000072479248,
            "data": [
                "prisoner,1.386,0.600,0.480,0.000,0.999,0.000,0.042",
                "victimM,1.531,0.600,-1.313,0.000,-0.996,0.000,0.089",
                "citizenF,0.871,0.600,-3.051,0.000,0.322,0.000,0.947",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 4.017000198364258,
            "data": [
                "prisoner,1.388,0.600,0.458,0.000,0.999,0.000,0.042",
                "victimM,1.531,0.600,-1.325,0.000,-0.996,0.000,0.091",
                "citizenF,0.876,0.600,-3.046,0.000,0.321,0.000,0.947",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 4.033999919891357,
            "data": [
                "prisoner,1.391,0.600,0.427,0.000,0.999,0.000,0.042",
                "victimM,1.532,0.600,-1.341,0.000,-0.996,0.000,0.094",
                "citizenF,0.884,0.600,-3.039,0.000,0.319,0.000,0.948",
                "observationCamera,1.859,0.875,-2.868,0.013,-0.068,0.000,0.998"
            ]
        },
        {
            "time": 4.051000118255615,
            "data": [
                "prisoner,1.394,0.600,0.395,0.000,0.999,0.000,0.042",
                "victimM,1.532,0.600,-1.356,0.000,-0.995,0.000,0.097",
                "citizenF,0.891,0.600,-3.032,0.000,0.318,0.000,0.948",
                "observationCamera,1.860,0.875,-2.868,0.013,-0.069,0.000,0.998"
            ]
        },
        {
            "time": 4.072000026702881,
            "data": [
                "prisoner,1.398,0.600,0.360,0.000,0.999,0.000,0.042",
                "victimM,1.532,0.600,-1.372,0.000,-0.995,0.000,0.099",
                "citizenF,0.899,0.600,-3.025,0.000,0.316,0.000,0.949",
                "observationCamera,1.861,0.875,-2.868,0.014,-0.070,0.001,0.997"
            ]
        },
        {
            "time": 4.0879998207092289,
            "data": [
                "prisoner,1.402,0.600,0.313,0.000,0.999,0.000,0.042",
                "victimM,1.533,0.600,-1.391,0.000,-0.995,0.000,0.103",
                "citizenF,0.907,0.600,-3.016,0.000,0.314,0.000,0.949",
                "observationCamera,1.862,0.875,-2.869,0.014,-0.072,0.001,0.997"
            ]
        },
        {
            "time": 4.103000164031982,
            "data": [
                "prisoner,1.405,0.600,0.278,0.000,0.999,0.000,0.042",
                "victimM,1.533,0.600,-1.405,0.000,-0.994,0.000,0.105",
                "citizenF,0.914,0.600,-3.010,0.000,0.313,0.000,0.950",
                "observationCamera,1.864,0.875,-2.869,0.014,-0.074,0.001,0.997"
            ]
        },
        {
            "time": 4.119999885559082,
            "data": [
                "prisoner,1.408,0.600,0.241,0.000,0.999,0.000,0.042",
                "victimM,1.533,0.600,-1.419,0.000,-0.994,0.000,0.108",
                "citizenF,0.920,0.600,-3.004,0.000,0.312,0.000,0.950",
                "observationCamera,1.866,0.876,-2.870,0.015,-0.076,0.001,0.997"
            ]
        },
        {
            "time": 4.138000011444092,
            "data": [
                "prisoner,1.412,0.600,0.197,0.000,0.999,0.000,0.042",
                "victimM,1.533,0.600,-1.435,0.000,-0.994,0.000,0.110",
                "citizenF,0.927,0.600,-2.997,0.000,0.310,0.000,0.951",
                "observationCamera,1.868,0.876,-2.870,0.015,-0.079,0.001,0.997"
            ]
        },
        {
            "time": 4.15500020980835,
            "data": [
                "prisoner,1.416,0.600,0.149,0.000,0.999,0.000,0.042",
                "victimM,1.534,0.600,-1.452,0.000,-0.994,0.000,0.113",
                "citizenF,0.935,0.600,-2.989,0.000,0.309,0.000,0.951",
                "observationCamera,1.870,0.876,-2.871,0.016,-0.083,0.001,0.996"
            ]
        },
        {
            "time": 4.173999786376953,
            "data": [
                "prisoner,1.420,0.600,0.104,0.000,0.999,0.000,0.042",
                "victimM,1.534,0.600,-1.467,0.000,-0.993,0.000,0.116",
                "citizenF,0.941,0.600,-2.983,0.000,0.307,0.000,0.952",
                "observationCamera,1.873,0.877,-2.872,0.017,-0.086,0.001,0.996"
            ]
        },
        {
            "time": 4.190000057220459,
            "data": [
                "prisoner,1.424,0.600,0.048,0.000,0.999,0.000,0.042",
                "victimM,1.534,0.600,-1.484,0.000,-0.993,0.000,0.119",
                "citizenF,0.949,0.600,-2.975,0.000,0.306,0.000,0.952",
                "observationCamera,1.877,0.877,-2.873,0.018,-0.091,0.001,0.996"
            ]
        },
        {
            "time": 4.206999778747559,
            "data": [
                "prisoner,1.428,0.600,0.003,0.000,0.999,0.000,0.042",
                "victimM,1.534,0.600,-1.499,0.000,-0.993,0.000,0.121",
                "citizenF,0.955,0.600,-2.969,0.000,0.305,0.000,0.952",
                "observationCamera,1.880,0.878,-2.874,0.018,-0.095,0.001,0.995"
            ]
        },
        {
            "time": 4.2230000495910648,
            "data": [
                "prisoner,1.432,0.600,-0.049,0.000,0.999,0.000,0.042",
                "victimM,1.535,0.600,-1.514,0.000,-0.992,0.000,0.124",
                "citizenF,0.962,0.600,-2.962,0.000,0.303,0.000,0.953",
                "observationCamera,1.883,0.878,-2.875,0.019,-0.099,0.002,0.995"
            ]
        },
        {
            "time": 4.242000102996826,
            "data": [
                "prisoner,1.436,0.600,-0.100,0.000,0.999,0.000,0.042",
                "victimM,1.535,0.600,-1.529,0.000,-0.992,0.000,0.126",
                "citizenF,0.968,0.600,-2.956,0.000,0.302,0.000,0.953",
                "observationCamera,1.887,0.879,-2.876,0.020,-0.104,0.002,0.994"
            ]
        },
        {
            "time": 4.257999897003174,
            "data": [
                "prisoner,1.441,0.600,-0.159,0.000,0.999,0.000,0.042",
                "victimM,1.535,0.600,-1.547,0.000,-0.992,0.000,0.129",
                "citizenF,0.975,0.600,-2.948,0.000,0.301,0.000,0.954",
                "observationCamera,1.892,0.879,-2.878,0.021,-0.109,0.002,0.994"
            ]
        },
        {
            "time": 4.28000020980835,
            "data": [
                "prisoner,1.445,0.600,-0.209,0.000,0.999,0.000,0.042",
                "victimM,1.535,0.600,-1.560,0.000,-0.991,0.000,0.131",
                "citizenF,0.981,0.600,-2.943,0.000,0.300,0.000,0.954",
                "observationCamera,1.896,0.880,-2.879,0.022,-0.114,0.002,0.993"
            ]
        },
        {
            "time": 4.294000148773193,
            "data": [
                "prisoner,1.450,0.600,-0.282,0.000,0.999,0.000,0.042",
                "victimM,1.536,0.600,-1.581,0.000,-0.991,0.000,0.135",
                "citizenF,0.989,0.600,-2.934,0.000,0.298,0.000,0.954",
                "observationCamera,1.902,0.881,-2.880,0.023,-0.122,0.002,0.992"
            ]
        },
        {
            "time": 4.310999870300293,
            "data": [
                "prisoner,1.454,0.600,-0.328,0.000,0.999,0.000,0.042",
                "victimM,1.536,0.600,-1.593,0.000,-0.991,0.000,0.137",
                "citizenF,0.994,0.600,-2.929,0.000,0.297,0.000,0.955",
                "observationCamera,1.905,0.881,-2.882,0.024,-0.126,0.003,0.992"
            ]
        },
        {
            "time": 4.327000141143799,
            "data": [
                "prisoner,1.458,0.600,-0.388,0.000,0.999,0.000,0.042",
                "victimM,1.536,0.600,-1.610,0.000,-0.990,0.000,0.139",
                "citizenF,1.000,0.600,-2.922,0.000,0.296,0.000,0.955",
                "observationCamera,1.911,0.882,-2.883,0.025,-0.132,0.003,0.991"
            ]
        },
        {
            "time": 4.34499979019165,
            "data": [
                "prisoner,1.463,0.600,-0.441,0.000,0.999,0.000,0.042",
                "victimM,1.537,0.600,-1.624,0.000,-0.990,0.000,0.141",
                "citizenF,1.005,0.600,-2.917,0.000,0.295,0.000,0.955",
                "observationCamera,1.915,0.883,-2.885,0.027,-0.138,0.003,0.990"
            ]
        },
        {
            "time": 4.36299991607666,
            "data": [
                "prisoner,1.467,0.600,-0.503,0.000,0.999,0.000,0.042",
                "victimM,1.537,0.600,-1.640,0.000,-0.990,0.000,0.144",
                "citizenF,1.011,0.600,-2.910,0.000,0.294,0.000,0.956",
                "observationCamera,1.921,0.884,-2.886,0.028,-0.145,0.004,0.989"
            ]
        },
        {
            "time": 4.381999969482422,
            "data": [
                "prisoner,1.472,0.600,-0.567,0.000,0.999,0.000,0.042",
                "victimM,1.537,0.600,-1.657,0.000,-0.989,0.000,0.147",
                "citizenF,1.017,0.600,-2.904,0.000,0.293,0.000,0.956",
                "observationCamera,1.927,0.885,-2.888,0.029,-0.152,0.004,0.988"
            ]
        },
        {
            "time": 4.4019999504089359,
            "data": [
                "prisoner,1.477,0.600,-0.631,0.000,0.999,0.000,0.042",
                "victimM,1.537,0.600,-1.674,0.000,-0.989,0.000,0.149",
                "citizenF,1.023,0.600,-2.897,0.000,0.292,0.000,0.957",
                "observationCamera,1.933,0.885,-2.890,0.030,-0.159,0.005,0.987"
            ]
        },
        {
            "time": 4.415999889373779,
            "data": [
                "prisoner,1.482,0.600,-0.702,0.000,0.999,0.000,0.042",
                "victimM,1.538,0.600,-1.692,0.000,-0.988,0.000,0.152",
                "citizenF,1.030,0.600,-2.890,0.000,0.291,0.000,0.957",
                "observationCamera,1.940,0.886,-2.892,0.032,-0.167,0.005,0.985"
            ]
        },
        {
            "time": 4.432000160217285,
            "data": [
                "prisoner,1.486,0.600,-0.751,0.000,0.999,0.000,0.042",
                "victimM,1.538,0.600,-1.705,0.000,-0.988,0.000,0.154",
                "citizenF,1.034,0.600,-2.885,0.000,0.290,0.000,0.957",
                "observationCamera,1.945,0.887,-2.893,0.033,-0.173,0.005,0.984"
            ]
        },
        {
            "time": 4.449999809265137,
            "data": [
                "prisoner,1.490,0.600,-0.808,0.000,0.999,0.000,0.042",
                "victimM,1.538,0.600,-1.720,0.000,-0.988,0.000,0.156",
                "citizenF,1.039,0.600,-2.880,0.000,0.289,0.000,0.957",
                "observationCamera,1.951,0.888,-2.895,0.034,-0.179,0.006,0.983"
            ]
        },
        {
            "time": 4.4679999351501469,
            "data": [
                "prisoner,1.494,0.600,-0.872,0.000,0.999,0.000,0.042",
                "victimM,1.538,0.600,-1.736,0.000,-0.987,0.000,0.158",
                "citizenF,1.044,0.600,-2.874,0.000,0.288,0.000,0.958",
                "observationCamera,1.958,0.889,-2.897,0.036,-0.186,0.006,0.982"
            ]
        },
        {
            "time": 4.48799991607666,
            "data": [
                "prisoner,1.499,0.600,-0.934,0.000,0.999,0.000,0.042",
                "victimM,1.539,0.600,-1.752,0.000,-0.987,0.000,0.160",
                "citizenF,1.050,0.600,-2.868,0.000,0.287,0.000,0.958",
                "observationCamera,1.965,0.890,-2.899,0.037,-0.194,0.007,0.980"
            ]
        },
        {
            "time": 4.505000114440918,
            "data": [
                "prisoner,1.504,0.600,-1.005,0.000,0.999,0.000,0.042",
                "victimM,1.539,0.600,-1.771,0.000,-0.987,0.000,0.163",
                "citizenF,1.055,0.600,-2.862,0.000,0.286,0.000,0.958",
                "observationCamera,1.972,0.891,-2.901,0.038,-0.202,0.008,0.979"
            ]
        },
        {
            "time": 4.519000053405762,
            "data": [
                "prisoner,1.508,0.600,-1.062,0.000,0.999,0.000,0.042",
                "victimM,1.539,0.600,-1.786,0.000,-0.986,0.000,0.165",
                "citizenF,1.060,0.600,-2.857,0.000,0.285,0.000,0.958",
                "observationCamera,1.979,0.892,-2.903,0.040,-0.209,0.008,0.977"
            ]
        },
        {
            "time": 4.534999847412109,
            "data": [
                "prisoner,1.511,0.600,-1.110,0.000,0.999,0.000,0.042",
                "victimM,1.540,0.600,-1.799,0.000,-0.986,0.000,0.166",
                "citizenF,1.064,0.600,-2.852,0.000,0.284,0.000,0.959",
                "observationCamera,1.984,0.893,-2.905,0.041,-0.215,0.009,0.976"
            ]
        },
        {
            "time": 4.552999973297119,
            "data": [
                "prisoner,1.515,0.600,-1.167,0.000,0.999,0.000,0.042",
                "victimM,1.540,0.600,-1.814,0.000,-0.986,0.000,0.168",
                "citizenF,1.068,0.600,-2.848,0.000,0.284,0.000,0.959",
                "observationCamera,1.991,0.894,-2.907,0.042,-0.221,0.009,0.974"
            ]
        },
        {
            "time": 4.570000171661377,
            "data": [
                "prisoner,1.520,0.600,-1.225,0.000,0.999,0.000,0.042",
                "victimM,1.540,0.600,-1.830,0.000,-0.985,0.000,0.170",
                "citizenF,1.072,0.600,-2.843,0.000,0.283,0.000,0.959",
                "observationCamera,1.998,0.895,-2.909,0.043,-0.228,0.010,0.973"
            ]
        },
        {
            "time": 4.589000225067139,
            "data": [
                "prisoner,1.524,0.600,-1.281,0.000,0.999,0.000,0.042",
                "victimM,1.540,0.600,-1.845,0.000,-0.985,0.000,0.172",
                "citizenF,1.076,0.600,-2.838,0.000,0.282,0.000,0.959",
                "observationCamera,2.005,0.896,-2.911,0.045,-0.235,0.011,0.971"
            ]
        },
        {
            "time": 4.605999946594238,
            "data": [
                "prisoner,1.528,0.600,-1.344,0.000,0.999,0.000,0.042",
                "victimM,1.541,0.600,-1.863,0.000,-0.985,0.000,0.174",
                "citizenF,1.081,0.600,-2.833,0.000,0.281,0.000,0.960",
                "observationCamera,2.013,0.897,-2.914,0.046,-0.243,0.011,0.969"
            ]
        },
        {
            "time": 4.622000217437744,
            "data": [
                "prisoner,1.532,0.600,-1.400,0.000,0.999,0.000,0.042",
                "victimM,1.541,0.600,-1.879,0.000,-0.984,0.000,0.176",
                "citizenF,1.085,0.600,-2.828,0.000,0.281,0.000,0.960",
                "observationCamera,2.020,0.898,-2.916,0.047,-0.250,0.012,0.967"
            ]
        },
        {
            "time": 4.63700008392334,
            "data": [
                "prisoner,1.535,0.600,-1.448,0.000,0.999,0.000,0.042",
                "victimM,1.541,0.600,-1.893,0.000,-0.984,0.000,0.177",
                "citizenF,1.088,0.600,-2.824,0.000,0.280,0.000,0.960",
                "observationCamera,2.027,0.899,-2.918,0.048,-0.256,0.013,0.965"
            ]
        },
        {
            "time": 4.65500020980835,
            "data": [
                "prisoner,1.539,0.600,-1.495,0.000,0.999,0.000,0.042",
                "victimM,1.541,0.600,-1.907,0.000,-0.984,0.000,0.179",
                "citizenF,1.092,0.600,-2.820,0.000,0.280,0.000,0.960",
                "observationCamera,2.033,0.900,-2.920,0.049,-0.262,0.013,0.964"
            ]
        },
        {
            "time": 4.671999931335449,
            "data": [
                "prisoner,1.542,0.600,-1.548,0.000,0.999,0.000,0.042",
                "victimM,1.542,0.600,-1.923,0.000,-0.984,0.000,0.180",
                "citizenF,1.095,0.600,-2.816,0.000,0.279,0.000,0.960",
                "observationCamera,2.040,0.901,-2.922,0.050,-0.268,0.014,0.962"
            ]
        },
        {
            "time": 4.691999912261963,
            "data": [
                "prisoner,1.546,0.600,-1.596,0.000,0.999,0.000,0.042",
                "victimM,1.542,0.600,-1.938,0.000,-0.983,0.000,0.182",
                "citizenF,1.098,0.600,-2.812,0.000,0.278,0.000,0.960",
                "observationCamera,2.047,0.902,-2.924,0.052,-0.274,0.014,0.960"
            ]
        },
        {
            "time": 4.706999778747559,
            "data": [
                "prisoner,1.550,0.600,-1.653,0.000,0.999,0.000,0.042",
                "victimM,1.542,0.600,-1.957,0.000,-0.983,0.000,0.183",
                "citizenF,1.102,0.600,-2.808,0.000,0.278,0.000,0.961",
                "observationCamera,2.056,0.903,-2.926,0.053,-0.281,0.015,0.958"
            ]
        },
        {
            "time": 4.71999979019165,
            "data": [
                "prisoner,1.552,0.600,-1.693,0.000,0.999,0.000,0.042",
                "victimM,1.542,0.600,-1.971,0.000,-0.983,0.000,0.185",
                "citizenF,1.105,0.600,-2.805,0.000,0.277,0.000,0.961",
                "observationCamera,2.062,0.904,-2.928,0.054,-0.286,0.016,0.957"
            ]
        },
        {
            "time": 4.736999988555908,
            "data": [
                "prisoner,1.555,0.600,-1.728,0.000,0.999,0.000,0.042",
                "victimM,1.543,0.600,-1.983,0.000,-0.983,0.000,0.186",
                "citizenF,1.107,0.600,-2.802,0.000,0.277,0.000,0.961",
                "observationCamera,2.068,0.905,-2.930,0.054,-0.291,0.016,0.955"
            ]
        },
        {
            "time": 4.752999782562256,
            "data": [
                "prisoner,1.558,0.600,-1.770,0.000,0.999,0.000,0.042",
                "victimM,1.543,0.600,-1.998,0.000,-0.982,0.000,0.187",
                "citizenF,1.110,0.600,-2.799,0.000,0.277,0.000,0.961",
                "observationCamera,2.075,0.906,-2.932,0.055,-0.296,0.017,0.953"
            ]
        },
        {
            "time": 4.769999980926514,
            "data": [
                "prisoner,1.560,0.600,-1.809,0.000,0.999,0.000,0.042",
                "victimM,1.543,0.600,-2.013,0.000,-0.982,0.000,0.188",
                "citizenF,1.112,0.600,-2.796,0.000,0.276,0.000,0.961",
                "observationCamera,2.081,0.907,-2.934,0.056,-0.301,0.018,0.952"
            ]
        },
        {
            "time": 4.7870001792907719,
            "data": [
                "prisoner,1.563,0.600,-1.848,0.000,0.999,0.000,0.042",
                "victimM,1.543,0.600,-2.028,0.000,-0.982,0.000,0.189",
                "citizenF,1.115,0.600,-2.793,0.000,0.276,0.000,0.961",
                "observationCamera,2.088,0.908,-2.936,0.057,-0.306,0.018,0.950"
            ]
        },
        {
            "time": 4.804999828338623,
            "data": [
                "prisoner,1.566,0.600,-1.884,0.000,0.999,0.000,0.042",
                "victimM,1.544,0.600,-2.043,0.000,-0.982,0.000,0.190",
                "citizenF,1.117,0.600,-2.790,0.000,0.275,0.000,0.961",
                "observationCamera,2.095,0.909,-2.938,0.058,-0.310,0.019,0.949"
            ]
        },
        {
            "time": 4.821000099182129,
            "data": [
                "prisoner,1.568,0.600,-1.920,0.000,0.999,0.000,0.042",
                "victimM,1.544,0.600,-2.060,0.000,-0.982,0.000,0.191",
                "citizenF,1.119,0.600,-2.788,0.000,0.275,0.000,0.961",
                "observationCamera,2.102,0.910,-2.940,0.059,-0.315,0.019,0.947"
            ]
        },
        {
            "time": 4.835000038146973,
            "data": [
                "prisoner,1.570,0.600,-1.952,0.000,0.999,0.000,0.042",
                "victimM,1.544,0.600,-2.075,0.000,-0.981,0.000,0.192",
                "citizenF,1.121,0.600,-2.785,0.000,0.275,0.000,0.962",
                "observationCamera,2.109,0.911,-2.942,0.059,-0.319,0.020,0.946"
            ]
        },
        {
            "time": 4.8520002365112309,
            "data": [
                "prisoner,1.572,0.600,-1.976,0.000,0.999,0.000,0.042",
                "victimM,1.544,0.600,-2.087,0.000,-0.981,0.000,0.193",
                "citizenF,1.122,0.600,-2.784,0.000,0.274,0.000,0.962",
                "observationCamera,2.114,0.912,-2.944,0.060,-0.322,0.020,0.945"
            ]
        },
        {
            "time": 4.868000030517578,
            "data": [
                "prisoner,1.574,0.600,-2.005,0.000,0.999,0.000,0.042",
                "victimM,1.545,0.600,-2.103,0.000,-0.981,0.000,0.194",
                "citizenF,1.124,0.600,-2.782,0.000,0.274,0.000,0.962",
                "observationCamera,2.121,0.913,-2.946,0.061,-0.326,0.021,0.943"
            ]
        },
        {
            "time": 4.883999824523926,
            "data": [
                "prisoner,1.575,0.600,-2.028,0.000,0.999,0.000,0.042",
                "victimM,1.545,0.600,-2.117,0.000,-0.981,0.000,0.194",
                "citizenF,1.125,0.600,-2.780,0.000,0.274,0.000,0.962",
                "observationCamera,2.127,0.913,-2.947,0.061,-0.329,0.021,0.942"
            ]
        },
        {
            "time": 4.901000022888184,
            "data": [
                "prisoner,1.577,0.600,-2.050,0.000,0.999,0.000,0.042",
                "victimM,1.545,0.600,-2.132,0.000,-0.981,0.000,0.195",
                "citizenF,1.127,0.600,-2.778,0.000,0.274,0.000,0.962",
                "observationCamera,2.133,0.914,-2.949,0.061,-0.331,0.021,0.941"
            ]
        },
        {
            "time": 4.919000148773193,
            "data": [
                "prisoner,1.578,0.600,-2.070,0.000,0.999,0.000,0.042",
                "victimM,1.545,0.600,-2.148,0.000,-0.981,0.000,0.195",
                "citizenF,1.128,0.600,-2.777,0.000,0.274,0.000,0.962",
                "observationCamera,2.139,0.915,-2.951,0.062,-0.334,0.022,0.940"
            ]
        },
        {
            "time": 4.934999942779541,
            "data": [
                "prisoner,1.579,0.600,-2.088,0.000,0.999,0.000,0.042",
                "victimM,1.546,0.600,-2.164,0.000,-0.981,0.000,0.196",
                "citizenF,1.129,0.600,-2.776,0.000,0.273,0.000,0.962",
                "observationCamera,2.146,0.916,-2.953,0.062,-0.336,0.022,0.939"
            ]
        },
        {
            "time": 4.948999881744385,
            "data": [
                "prisoner,1.580,0.600,-2.101,0.000,0.999,0.000,0.042",
                "victimM,1.546,0.600,-2.179,0.000,-0.981,0.000,0.196",
                "citizenF,1.130,0.600,-2.775,0.000,0.273,0.000,0.962",
                "observationCamera,2.152,0.917,-2.955,0.063,-0.338,0.022,0.939"
            ]
        },
        {
            "time": 4.966000080108643,
            "data": [
                "prisoner,1.581,0.600,-2.111,0.000,0.999,0.000,0.042",
                "victimM,1.546,0.600,-2.191,0.000,-0.981,0.000,0.196",
                "citizenF,1.130,0.600,-2.774,0.000,0.273,0.000,0.962",
                "observationCamera,2.156,0.918,-2.956,0.063,-0.339,0.023,0.938"
            ]
        },
        {
            "time": 4.98199987411499,
            "data": [
                "prisoner,1.582,0.600,-2.119,0.000,0.999,0.000,0.042",
                "victimM,1.546,0.600,-2.207,0.000,-0.980,0.000,0.197",
                "citizenF,1.131,0.600,-2.773,0.000,0.273,0.000,0.962",
                "observationCamera,2.162,0.918,-2.958,0.063,-0.340,0.023,0.938"
            ]
        },
        {
            "time": 4.999000072479248,
            "data": [
                "prisoner,1.582,0.600,-2.124,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.221,0.000,-0.980,0.000,0.197",
                "citizenF,1.131,0.600,-2.773,0.000,0.273,0.000,0.962",
                "observationCamera,2.167,0.919,-2.959,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.013999938964844,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.237,0.000,-0.980,0.000,0.197",
                "citizenF,1.131,0.600,-2.773,0.000,0.273,0.000,0.962",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.0329999923706059,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.000,-0.980,0.000,0.197",
                "citizenF,1.131,0.600,-2.773,0.000,0.273,0.000,0.962",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.048999786376953,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.000,-0.980,0.002,0.197",
                "citizenF,1.131,0.600,-2.773,0.000,0.273,0.000,0.962",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.065000057220459,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.001,-0.980,0.005,0.197",
                "citizenF,1.131,0.600,-2.773,0.000,0.274,0.000,0.962",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.079999923706055,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.002,-0.980,0.008,0.197",
                "citizenF,1.131,0.600,-2.774,0.000,0.274,0.000,0.962",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.0960001945495609,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.003,-0.980,0.013,0.197",
                "citizenF,1.130,0.600,-2.774,0.000,0.274,0.000,0.962",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.111999988555908,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.004,-0.980,0.018,0.197",
                "citizenF,1.130,0.600,-2.775,0.000,0.275,0.000,0.962",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.127999782562256,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.005,-0.980,0.024,0.197",
                "citizenF,1.130,0.600,-2.775,0.000,0.275,0.000,0.961",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.146999835968018,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.006,-0.980,0.032,0.197",
                "citizenF,1.129,0.600,-2.776,0.000,0.276,0.000,0.961",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.164000034332275,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.008,-0.980,0.041,0.197",
                "citizenF,1.129,0.600,-2.777,0.000,0.277,0.000,0.961",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.177000045776367,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.010,-0.979,0.051,0.197",
                "citizenF,1.128,0.600,-2.778,0.000,0.277,0.000,0.961",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.192999839782715,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.012,-0.979,0.058,0.196",
                "citizenF,1.128,0.600,-2.779,0.000,0.278,0.000,0.961",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.210000038146973,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.014,-0.978,0.069,0.196",
                "citizenF,1.127,0.600,-2.780,0.000,0.279,0.000,0.960",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.2270002365112309,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.016,-0.977,0.081,0.196",
                "citizenF,1.127,0.600,-2.781,0.000,0.280,0.000,0.960",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.243000030517578,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.019,-0.976,0.094,0.196",
                "citizenF,1.126,0.600,-2.782,0.000,0.281,0.000,0.960",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.260000228881836,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.021,-0.975,0.106,0.196",
                "citizenF,1.125,0.600,-2.784,0.000,0.282,0.000,0.959",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.2779998779296879,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.024,-0.973,0.121,0.195",
                "citizenF,1.125,0.600,-2.785,0.000,0.283,0.000,0.959",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.290999889373779,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.027,-0.971,0.136,0.195",
                "citizenF,1.124,0.600,-2.787,0.000,0.284,0.000,0.959",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.307000160217285,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.030,-0.969,0.148,0.195",
                "citizenF,1.123,0.600,-2.788,0.000,0.285,0.000,0.958",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.322999954223633,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.033,-0.967,0.163,0.194",
                "citizenF,1.122,0.600,-2.790,0.000,0.286,0.000,0.958",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.339000225067139,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.036,-0.964,0.179,0.194",
                "citizenF,1.121,0.600,-2.791,0.000,0.288,0.000,0.958",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.355000019073486,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.039,-0.961,0.195,0.193",
                "citizenF,1.121,0.600,-2.793,0.000,0.289,0.000,0.957",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.373000144958496,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.042,-0.957,0.211,0.192",
                "citizenF,1.120,0.600,-2.795,0.000,0.290,0.000,0.957",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.389999866485596,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.046,-0.953,0.231,0.191",
                "citizenF,1.118,0.600,-2.797,0.000,0.292,0.000,0.957",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.4039998054504398,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.050,-0.948,0.249,0.190",
                "citizenF,1.117,0.600,-2.799,0.000,0.293,0.000,0.956",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.420000076293945,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.053,-0.944,0.264,0.190",
                "citizenF,1.116,0.600,-2.801,0.000,0.294,0.000,0.956",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.435999870300293,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.057,-0.939,0.282,0.189",
                "citizenF,1.115,0.600,-2.803,0.000,0.295,0.000,0.955",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.452000141143799,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.060,-0.934,0.300,0.187",
                "citizenF,1.114,0.600,-2.805,0.000,0.297,0.000,0.955",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.4679999351501469,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.064,-0.927,0.318,0.186",
                "citizenF,1.113,0.600,-2.807,0.000,0.298,0.000,0.954",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.486000061035156,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.067,-0.921,0.336,0.185",
                "citizenF,1.112,0.600,-2.809,0.000,0.300,0.000,0.954",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.502999782562256,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.071,-0.913,0.356,0.183",
                "citizenF,1.110,0.600,-2.812,0.000,0.301,0.000,0.954",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.517000198364258,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.075,-0.906,0.374,0.182",
                "citizenF,1.109,0.600,-2.814,0.000,0.303,0.000,0.953",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.5329999923706059,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.078,-0.900,0.390,0.181",
                "citizenF,1.108,0.600,-2.817,0.000,0.304,0.000,0.953",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.548999786376953,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.082,-0.892,0.407,0.179",
                "citizenF,1.107,0.600,-2.819,0.000,0.305,0.000,0.952",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.565999984741211,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.085,-0.883,0.425,0.177",
                "citizenF,1.105,0.600,-2.822,0.000,0.307,0.000,0.952",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.581999778747559,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.089,-0.875,0.442,0.176",
                "citizenF,1.104,0.600,-2.824,0.000,0.308,0.000,0.951",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.599999904632568,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.092,-0.866,0.459,0.174",
                "citizenF,1.103,0.600,-2.827,0.000,0.309,0.000,0.951",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.617000102996826,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.096,-0.856,0.477,0.172",
                "citizenF,1.101,0.600,-2.830,0.000,0.311,0.000,0.950",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.630000114440918,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.099,-0.847,0.494,0.170",
                "citizenF,1.100,0.600,-2.833,0.000,0.312,0.000,0.950",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.645999908447266,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.102,-0.839,0.507,0.168",
                "citizenF,1.098,0.600,-2.835,0.000,0.313,0.000,0.950",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.663000106811523,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.105,-0.830,0.521,0.167",
                "citizenF,1.097,0.600,-2.838,0.000,0.315,0.000,0.949",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.678999900817871,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.108,-0.821,0.536,0.165",
                "citizenF,1.095,0.600,-2.841,0.000,0.316,0.000,0.949",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.695000171661377,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.110,-0.812,0.550,0.163",
                "citizenF,1.094,0.600,-2.844,0.000,0.317,0.000,0.948",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.714000225067139,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.113,-0.803,0.563,0.161",
                "citizenF,1.092,0.600,-2.847,0.000,0.318,0.000,0.948",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.730000019073486,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.116,-0.793,0.577,0.159",
                "citizenF,1.090,0.600,-2.850,0.000,0.320,0.000,0.947",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.74399995803833,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.118,-0.783,0.589,0.157",
                "citizenF,1.089,0.600,-2.853,0.000,0.321,0.000,0.947",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.760000228881836,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.120,-0.776,0.599,0.156",
                "citizenF,1.087,0.600,-2.856,0.000,0.322,0.000,0.947",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.776000022888184,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.122,-0.768,0.609,0.154",
                "citizenF,1.086,0.600,-2.859,0.000,0.323,0.000,0.946",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.791999816894531,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.124,-0.760,0.619,0.153",
                "citizenF,1.084,0.600,-2.862,0.000,0.324,0.000,0.946",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.808000087738037,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.126,-0.753,0.628,0.151",
                "citizenF,1.082,0.600,-2.865,0.000,0.325,0.000,0.946",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.827000141143799,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.128,-0.745,0.637,0.150",
                "citizenF,1.081,0.600,-2.868,0.000,0.326,0.000,0.945",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.843999862670898,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.130,-0.737,0.646,0.148",
                "citizenF,1.079,0.600,-2.872,0.000,0.327,0.000,0.945",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.855999946594238,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.131,-0.731,0.654,0.147",
                "citizenF,1.077,0.600,-2.876,0.000,0.328,0.000,0.945",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.873000144958496,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.132,-0.726,0.659,0.146",
                "citizenF,1.076,0.600,-2.878,0.000,0.328,0.000,0.945",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.888999938964844,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.133,-0.721,0.665,0.145",
                "citizenF,1.074,0.600,-2.881,0.000,0.329,0.000,0.944",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.90500020980835,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.134,-0.716,0.670,0.144",
                "citizenF,1.072,0.600,-2.885,0.000,0.329,0.000,0.944",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.921000003814697,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.135,-0.712,0.675,0.143",
                "citizenF,1.070,0.600,-2.888,0.000,0.330,0.000,0.944",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.940000057220459,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.136,-0.708,0.678,0.142",
                "citizenF,1.069,0.600,-2.891,0.000,0.330,0.000,0.944",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.956999778747559,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.137,-0.704,0.682,0.141",
                "citizenF,1.067,0.600,-2.895,0.000,0.331,0.000,0.944",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.96999979019165,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.137,-0.702,0.684,0.141",
                "citizenF,1.065,0.600,-2.899,0.000,0.331,0.000,0.944",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 5.986000061035156,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.138,-0.701,0.686,0.141",
                "citizenF,1.063,0.600,-2.902,0.000,0.331,0.000,0.944",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 6.001999855041504,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.138,-0.700,0.687,0.140",
                "citizenF,1.062,0.600,-2.905,0.000,0.331,0.000,0.944",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 6.01800012588501,
            "data": [
                "prisoner,1.582,0.600,-2.126,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,1.060,0.600,-2.908,0.000,0.331,0.000,0.944",
                "observationCamera,2.173,0.920,-2.961,0.063,-0.341,0.023,0.938"
            ]
        },
        {
            "time": 6.033999919891357,
            "data": [
                "prisoner,1.582,0.600,-2.127,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,1.058,0.600,-2.912,0.000,0.331,0.000,0.944",
                "observationCamera,2.168,0.920,-2.960,0.063,-0.341,0.023,0.937"
            ]
        },
        {
            "time": 6.054999828338623,
            "data": [
                "prisoner,1.581,0.600,-2.129,0.000,0.999,0.000,0.042",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,1.056,0.600,-2.916,0.000,0.328,0.000,0.945",
                "observationCamera,2.164,0.920,-2.960,0.063,-0.342,0.023,0.937"
            ]
        },
        {
            "time": 6.071000099182129,
            "data": [
                "prisoner,1.579,0.600,-2.133,0.000,0.999,0.000,0.041",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,1.053,0.600,-2.921,0.000,0.324,0.000,0.946",
                "observationCamera,2.157,0.919,-2.959,0.063,-0.344,0.023,0.937"
            ]
        },
        {
            "time": 6.083000183105469,
            "data": [
                "prisoner,1.577,0.600,-2.137,0.000,0.999,0.000,0.041",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,1.051,0.600,-2.926,0.000,0.319,0.000,0.948",
                "observationCamera,2.152,0.919,-2.958,0.063,-0.346,0.023,0.936"
            ]
        },
        {
            "time": 6.099999904632568,
            "data": [
                "prisoner,1.575,0.600,-2.141,0.000,0.999,0.000,0.040",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,1.049,0.600,-2.929,0.000,0.315,0.000,0.949",
                "observationCamera,2.149,0.919,-2.957,0.063,-0.347,0.023,0.935"
            ]
        },
        {
            "time": 6.114999771118164,
            "data": [
                "prisoner,1.572,0.600,-2.148,0.000,0.999,0.000,0.039",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,1.046,0.600,-2.935,0.000,0.308,0.000,0.951",
                "observationCamera,2.143,0.919,-2.956,0.064,-0.350,0.024,0.934"
            ]
        },
        {
            "time": 6.13100004196167,
            "data": [
                "prisoner,1.569,0.600,-2.154,0.000,0.999,0.000,0.038",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,1.043,0.600,-2.940,0.000,0.301,0.000,0.954",
                "observationCamera,2.138,0.918,-2.955,0.064,-0.353,0.024,0.933"
            ]
        },
        {
            "time": 6.146999835968018,
            "data": [
                "prisoner,1.566,0.600,-2.162,0.000,0.999,0.000,0.037",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,1.041,0.600,-2.945,0.000,0.293,0.000,0.956",
                "observationCamera,2.133,0.918,-2.955,0.064,-0.356,0.024,0.932"
            ]
        },
        {
            "time": 6.165999889373779,
            "data": [
                "prisoner,1.561,0.600,-2.171,0.000,0.999,0.000,0.036",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,1.038,0.600,-2.950,0.000,0.284,0.000,0.959",
                "observationCamera,2.128,0.918,-2.954,0.064,-0.359,0.025,0.931"
            ]
        },
        {
            "time": 6.182000160217285,
            "data": [
                "prisoner,1.556,0.600,-2.183,0.000,0.999,0.000,0.034",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,1.034,0.600,-2.957,0.000,0.272,0.000,0.962",
                "observationCamera,2.122,0.917,-2.953,0.064,-0.364,0.025,0.929"
            ]
        },
        {
            "time": 6.195000171661377,
            "data": [
                "prisoner,1.551,0.600,-2.194,0.000,0.999,0.000,0.032",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,1.031,0.600,-2.963,0.000,0.261,0.000,0.965",
                "observationCamera,2.116,0.917,-2.952,0.064,-0.369,0.025,0.927"
            ]
        },
        {
            "time": 6.210999965667725,
            "data": [
                "prisoner,1.547,0.600,-2.203,0.000,1.000,0.000,0.031",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,1.028,0.600,-2.968,0.000,0.253,0.000,0.968",
                "observationCamera,2.112,0.917,-2.951,0.065,-0.372,0.026,0.925"
            ]
        },
        {
            "time": 6.22599983215332,
            "data": [
                "prisoner,1.541,0.600,-2.215,0.000,1.000,0.000,0.029",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,1.025,0.600,-2.974,0.000,0.240,0.000,0.971",
                "observationCamera,2.106,0.917,-2.950,0.065,-0.378,0.026,0.923"
            ]
        },
        {
            "time": 6.242000102996826,
            "data": [
                "prisoner,1.535,0.600,-2.227,0.000,1.000,0.000,0.027",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,1.022,0.600,-2.980,0.000,0.229,0.000,0.973",
                "observationCamera,2.101,0.916,-2.949,0.065,-0.382,0.027,0.921"
            ]
        },
        {
            "time": 6.257999897003174,
            "data": [
                "prisoner,1.529,0.600,-2.240,0.000,1.000,0.000,0.025",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,1.019,0.600,-2.987,0.000,0.216,0.000,0.976",
                "observationCamera,2.095,0.916,-2.948,0.065,-0.388,0.027,0.919"
            ]
        },
        {
            "time": 6.2779998779296879,
            "data": [
                "prisoner,1.522,0.600,-2.254,0.000,1.000,0.000,0.023",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,1.015,0.600,-2.993,0.000,0.203,0.000,0.979",
                "observationCamera,2.089,0.916,-2.947,0.065,-0.394,0.028,0.916"
            ]
        },
        {
            "time": 6.295000076293945,
            "data": [
                "prisoner,1.513,0.600,-2.273,0.000,1.000,0.000,0.020",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,1.011,0.600,-3.001,0.000,0.186,0.000,0.983",
                "observationCamera,2.082,0.915,-2.946,0.066,-0.402,0.029,0.913"
            ]
        },
        {
            "time": 6.306000232696533,
            "data": [
                "prisoner,1.505,0.600,-2.289,0.000,1.000,0.000,0.017",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,1.007,0.600,-3.008,0.000,0.172,0.000,0.985",
                "observationCamera,2.076,0.915,-2.945,0.066,-0.409,0.029,0.910"
            ]
        },
        {
            "time": 6.321000099182129,
            "data": [
                "prisoner,1.500,0.600,-2.300,0.000,1.000,0.000,0.015",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,1.005,0.600,-3.013,0.000,0.162,0.000,0.987",
                "observationCamera,2.072,0.915,-2.944,0.066,-0.413,0.030,0.908"
            ]
        },
        {
            "time": 6.370999813079834,
            "data": [
                "prisoner,1.492,0.600,-2.315,0.000,1.000,0.000,0.012",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,1.002,0.600,-3.019,0.000,0.148,0.000,0.989",
                "observationCamera,2.066,0.915,-2.943,0.066,-0.420,0.031,0.905"
            ]
        },
        {
            "time": 6.446000099182129,
            "data": [
                "prisoner,1.465,0.600,-2.369,0.000,1.000,0.000,0.002",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.991,0.600,-3.040,0.000,0.103,0.000,0.995",
                "observationCamera,2.048,0.914,-2.940,0.067,-0.443,0.033,0.894"
            ]
        },
        {
            "time": 6.4730000495910648,
            "data": [
                "prisoner,1.421,0.600,-2.455,0.000,1.000,0.000,-0.016",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.975,0.600,-3.070,0.000,0.040,0.000,0.999",
                "observationCamera,2.021,0.912,-2.936,0.068,-0.480,0.037,0.874"
            ]
        },
        {
            "time": 6.482999801635742,
            "data": [
                "prisoner,1.404,0.600,-2.488,0.000,1.000,0.000,-0.023",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.969,0.600,-3.081,0.000,0.019,0.000,1.000",
                "observationCamera,2.012,0.912,-2.934,0.068,-0.494,0.039,0.866"
            ]
        },
        {
            "time": 6.494999885559082,
            "data": [
                "prisoner,1.398,0.600,-2.499,0.000,1.000,0.000,-0.026",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.967,0.600,-3.085,0.000,0.012,0.000,1.000",
                "observationCamera,2.008,0.912,-2.934,0.068,-0.499,0.039,0.863"
            ]
        },
        {
            "time": 6.506999969482422,
            "data": [
                "prisoner,1.390,0.600,-2.514,0.000,1.000,0.000,-0.029",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.965,0.600,-3.089,0.000,0.003,0.000,1.000",
                "observationCamera,2.004,0.912,-2.933,0.068,-0.506,0.040,0.859"
            ]
        },
        {
            "time": 6.52400016784668,
            "data": [
                "prisoner,1.381,0.600,-2.529,0.000,0.999,0.000,-0.033",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.093,0.000,0.000,0.000,1.000",
                "observationCamera,2.000,0.911,-2.932,0.068,-0.513,0.041,0.855"
            ]
        },
        {
            "time": 6.539999961853027,
            "data": [
                "prisoner,1.370,0.600,-2.550,0.000,0.999,0.000,-0.038",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.097,0.000,0.000,0.000,1.000",
                "observationCamera,1.994,0.911,-2.931,0.068,-0.522,0.042,0.849"
            ]
        },
        {
            "time": 6.557000160217285,
            "data": [
                "prisoner,1.359,0.600,-2.569,0.000,0.999,0.000,-0.043",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.101,0.000,0.000,0.000,1.000",
                "observationCamera,1.989,0.911,-2.931,0.068,-0.531,0.043,0.844"
            ]
        },
        {
            "time": 6.572999954223633,
            "data": [
                "prisoner,1.348,0.600,-2.589,0.000,0.999,0.000,-0.048",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.106,0.000,0.000,0.000,1.000",
                "observationCamera,1.983,0.911,-2.930,0.068,-0.540,0.044,0.838"
            ]
        },
        {
            "time": 6.5929999351501469,
            "data": [
                "prisoner,1.337,0.600,-2.609,0.000,0.999,0.000,-0.053",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.110,0.000,0.000,0.000,1.000",
                "observationCamera,1.978,0.910,-2.929,0.068,-0.549,0.045,0.832"
            ]
        },
        {
            "time": 6.611000061035156,
            "data": [
                "prisoner,1.322,0.600,-2.633,0.000,0.998,0.000,-0.060",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.115,0.000,0.000,0.000,1.000",
                "observationCamera,1.972,0.910,-2.928,0.068,-0.560,0.046,0.825"
            ]
        },
        {
            "time": 6.623000144958496,
            "data": [
                "prisoner,1.310,0.600,-2.654,0.000,0.998,0.000,-0.066",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.119,0.000,0.000,0.000,1.000",
                "observationCamera,1.967,0.910,-2.927,0.068,-0.569,0.047,0.818"
            ]
        },
        {
            "time": 6.638999938964844,
            "data": [
                "prisoner,1.302,0.600,-2.668,0.000,0.998,0.000,-0.071",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.122,0.000,0.000,0.000,1.000",
                "observationCamera,1.963,0.909,-2.926,0.068,-0.576,0.048,0.813"
            ]
        },
        {
            "time": 6.656000137329102,
            "data": [
                "prisoner,1.290,0.600,-2.687,0.000,0.997,0.000,-0.077",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.127,0.000,0.000,0.000,1.000",
                "observationCamera,1.958,0.909,-2.925,0.068,-0.585,0.049,0.807"
            ]
        },
        {
            "time": 6.672999858856201,
            "data": [
                "prisoner,1.278,0.600,-2.706,0.000,0.997,0.000,-0.083",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.131,0.000,0.000,0.000,1.000",
                "observationCamera,1.953,0.909,-2.925,0.068,-0.594,0.050,0.800"
            ]
        },
        {
            "time": 6.689000129699707,
            "data": [
                "prisoner,1.266,0.600,-2.726,0.000,0.996,0.000,-0.089",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.135,0.000,0.000,0.000,1.000",
                "observationCamera,1.949,0.909,-2.924,0.068,-0.603,0.051,0.793"
            ]
        },
        {
            "time": 6.710000038146973,
            "data": [
                "prisoner,1.254,0.600,-2.744,0.000,0.995,0.000,-0.096",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.139,0.000,0.000,0.000,1.000",
                "observationCamera,1.944,0.909,-2.923,0.068,-0.612,0.053,0.786"
            ]
        },
        {
            "time": 6.7270002365112309,
            "data": [
                "prisoner,1.239,0.600,-2.766,0.000,0.995,0.000,-0.104",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.145,0.000,0.000,0.000,1.000",
                "observationCamera,1.939,0.908,-2.922,0.067,-0.623,0.054,0.777"
            ]
        },
        {
            "time": 6.738999843597412,
            "data": [
                "prisoner,1.227,0.600,-2.784,0.000,0.994,0.000,-0.111",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.149,0.000,0.000,0.000,1.000",
                "observationCamera,1.935,0.908,-2.922,0.067,-0.632,0.055,0.770"
            ]
        },
        {
            "time": 6.75600004196167,
            "data": [
                "prisoner,1.218,0.600,-2.797,0.000,0.993,0.000,-0.117",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.152,0.000,0.000,0.000,1.000",
                "observationCamera,1.932,0.908,-2.921,0.067,-0.639,0.056,0.764"
            ]
        },
        {
            "time": 6.7729997634887699,
            "data": [
                "prisoner,1.206,0.600,-2.814,0.000,0.992,0.000,-0.124",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.157,0.000,0.000,0.000,1.000",
                "observationCamera,1.928,0.908,-2.921,0.067,-0.648,0.057,0.757"
            ]
        },
        {
            "time": 6.789999961853027,
            "data": [
                "prisoner,1.194,0.600,-2.830,0.000,0.991,0.000,-0.131",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.161,0.000,0.000,0.000,1.000",
                "observationCamera,1.925,0.908,-2.920,0.066,-0.656,0.058,0.749"
            ]
        },
        {
            "time": 6.811999797821045,
            "data": [
                "prisoner,1.181,0.600,-2.846,0.000,0.990,0.000,-0.139",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.165,0.000,0.000,0.000,1.000",
                "observationCamera,1.921,0.907,-2.919,0.066,-0.665,0.059,0.742"
            ]
        },
        {
            "time": 6.828000068664551,
            "data": [
                "prisoner,1.166,0.600,-2.866,0.000,0.989,0.000,-0.149",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.171,0.000,0.000,0.000,1.000",
                "observationCamera,1.917,0.907,-2.919,0.065,-0.676,0.060,0.732"
            ]
        },
        {
            "time": 6.8420000076293949,
            "data": [
                "prisoner,1.154,0.600,-2.879,0.000,0.988,0.000,-0.157",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.175,0.000,0.000,0.000,1.000",
                "observationCamera,1.914,0.907,-2.918,0.065,-0.684,0.061,0.724"
            ]
        },
        {
            "time": 6.854000091552734,
            "data": [
                "prisoner,1.145,0.600,-2.890,0.000,0.987,0.000,-0.163",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.178,0.000,0.000,0.000,1.000",
                "observationCamera,1.912,0.907,-2.918,0.065,-0.690,0.062,0.718"
            ]
        },
        {
            "time": 6.869999885559082,
            "data": [
                "prisoner,1.136,0.600,-2.900,0.000,0.986,0.000,-0.169",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.182,0.000,0.000,0.000,1.000",
                "observationCamera,1.910,0.907,-2.918,0.064,-0.696,0.063,0.712"
            ]
        },
        {
            "time": 6.885000228881836,
            "data": [
                "prisoner,1.126,0.600,-2.911,0.000,0.984,0.000,-0.177",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.186,0.000,0.000,0.000,1.000",
                "observationCamera,1.908,0.907,-2.917,0.064,-0.703,0.063,0.705"
            ]
        },
        {
            "time": 6.901000022888184,
            "data": [
                "prisoner,1.115,0.600,-2.922,0.000,0.983,0.000,-0.185",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.190,0.000,0.000,0.000,1.000",
                "observationCamera,1.906,0.907,-2.917,0.063,-0.710,0.064,0.698"
            ]
        },
        {
            "time": 6.921999931335449,
            "data": [
                "prisoner,1.105,0.600,-2.931,0.000,0.981,0.000,-0.193",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.194,0.000,0.000,0.000,1.000",
                "observationCamera,1.905,0.907,-2.917,0.063,-0.717,0.065,0.691"
            ]
        },
        {
            "time": 6.938000202178955,
            "data": [
                "prisoner,1.091,0.600,-2.944,0.000,0.979,0.000,-0.204",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.199,0.000,0.000,0.000,1.000",
                "observationCamera,1.903,0.906,-2.916,0.062,-0.726,0.066,0.681"
            ]
        },
        {
            "time": 6.951000213623047,
            "data": [
                "prisoner,1.080,0.600,-2.952,0.000,0.977,0.000,-0.212",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.203,0.000,0.000,0.000,1.000",
                "observationCamera,1.902,0.906,-2.916,0.062,-0.733,0.067,0.674"
            ]
        },
        {
            "time": 6.964000225067139,
            "data": [
                "prisoner,1.072,0.600,-2.958,0.000,0.976,0.000,-0.219",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.207,0.000,0.000,0.000,1.000",
                "observationCamera,1.901,0.906,-2.916,0.061,-0.738,0.067,0.668"
            ]
        },
        {
            "time": 6.98199987411499,
            "data": [
                "prisoner,1.064,0.600,-2.963,0.000,0.974,0.000,-0.226",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.210,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.061,-0.744,0.068,0.662"
            ]
        },
        {
            "time": 6.997000217437744,
            "data": [
                "prisoner,1.053,0.600,-2.969,0.000,0.972,0.000,-0.236",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.214,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.060,-0.750,0.069,0.655"
            ]
        },
        {
            "time": 7.013000011444092,
            "data": [
                "prisoner,1.044,0.600,-2.973,0.000,0.970,0.000,-0.244",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.218,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.756,0.069,0.648"
            ]
        },
        {
            "time": 7.03000020980835,
            "data": [
                "prisoner,1.034,0.600,-2.977,0.000,0.967,0.000,-0.254",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.222,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.044000148773193,
            "data": [
                "prisoner,1.023,0.600,-2.981,0.000,0.964,0.000,-0.265",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.227,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.057000160217285,
            "data": [
                "prisoner,1.015,0.600,-2.984,0.000,0.961,0.000,-0.276",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.230,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.071000099182129,
            "data": [
                "prisoner,1.006,0.600,-2.987,0.000,0.958,0.000,-0.287",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.234,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.085000038146973,
            "data": [
                "prisoner,0.996,0.600,-2.990,0.000,0.954,0.000,-0.299",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.237,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.0980000495910648,
            "data": [
                "prisoner,0.987,0.600,-2.993,0.000,0.950,0.000,-0.311",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.241,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.113999843597412,
            "data": [
                "prisoner,0.977,0.600,-2.996,0.000,0.946,0.000,-0.325",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.244,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.136000156402588,
            "data": [
                "prisoner,0.966,0.600,-3.000,0.000,0.940,0.000,-0.341",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.248,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.150000095367432,
            "data": [
                "prisoner,0.949,0.600,-3.004,0.000,0.931,0.000,-0.366",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.254,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.163000106811523,
            "data": [
                "prisoner,0.938,0.600,-3.007,0.000,0.924,0.000,-0.382",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.257,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.177999973297119,
            "data": [
                "prisoner,0.928,0.600,-3.010,0.000,0.917,0.000,-0.398",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.261,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.191999912261963,
            "data": [
                "prisoner,0.916,0.600,-3.013,0.000,0.909,0.000,-0.416",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.264,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.206999778747559,
            "data": [
                "prisoner,0.905,0.600,-3.015,0.000,0.901,0.000,-0.435",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.268,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.223999977111816,
            "data": [
                "prisoner,0.892,0.600,-3.018,0.000,0.891,0.000,-0.454",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.272,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.239999771118164,
            "data": [
                "prisoner,0.878,0.600,-3.021,0.000,0.879,0.000,-0.477",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.276,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.255000114440918,
            "data": [
                "prisoner,0.866,0.600,-3.024,0.000,0.867,0.000,-0.498",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.280,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.269000053405762,
            "data": [
                "prisoner,0.853,0.600,-3.027,0.000,0.855,0.000,-0.519",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.284,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.2829999923706059,
            "data": [
                "prisoner,0.841,0.600,-3.029,0.000,0.843,0.000,-0.538",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.288,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.297999858856201,
            "data": [
                "prisoner,0.829,0.600,-3.032,0.000,0.830,0.000,-0.557",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.291,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.313000202178955,
            "data": [
                "prisoner,0.816,0.600,-3.034,0.000,0.816,0.000,-0.578",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.295,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.327000141143799,
            "data": [
                "prisoner,0.803,0.600,-3.037,0.000,0.801,0.000,-0.598",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.299,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.3470001220703129,
            "data": [
                "prisoner,0.791,0.600,-3.039,0.000,0.786,0.000,-0.618",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.303,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.361999988555908,
            "data": [
                "prisoner,0.774,0.600,-3.042,0.000,0.764,0.000,-0.645",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.308,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.375999927520752,
            "data": [
                "prisoner,0.761,0.600,-3.045,0.000,0.746,0.000,-0.666",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.312,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.388999938964844,
            "data": [
                "prisoner,0.748,0.600,-3.047,0.000,0.729,0.000,-0.685",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.315,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.4029998779296879,
            "data": [
                "prisoner,0.738,0.600,-3.049,0.000,0.713,0.000,-0.702",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.319,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.421000003814697,
            "data": [
                "prisoner,0.725,0.600,-3.051,0.000,0.694,0.000,-0.720",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.322,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.473999977111816,
            "data": [
                "prisoner,0.710,0.600,-3.053,0.000,0.670,0.000,-0.743",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.327,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.539000034332275,
            "data": [
                "prisoner,0.665,0.600,-3.060,0.000,0.595,0.000,-0.804",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.340,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.598999977111816,
            "data": [
                "prisoner,0.611,0.600,-3.068,0.000,0.494,0.000,-0.869",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.347,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.666999816894531,
            "data": [
                "prisoner,0.565,0.600,-3.074,0.000,0.400,0.000,-0.916",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.347,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.7210001945495609,
            "data": [
                "prisoner,0.517,0.600,-3.080,0.000,0.295,0.000,-0.956",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.347,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.743000030517578,
            "data": [
                "prisoner,0.483,0.600,-3.084,0.000,0.217,0.000,-0.976",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.347,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.755000114440918,
            "data": [
                "prisoner,0.470,0.600,-3.085,0.000,0.188,0.000,-0.982",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.347,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.764999866485596,
            "data": [
                "prisoner,0.464,0.600,-3.086,0.000,0.172,0.000,-0.985",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.347,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.775000095367432,
            "data": [
                "prisoner,0.458,0.600,-3.086,0.000,0.159,0.000,-0.987",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.347,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.790999889373779,
            "data": [
                "prisoner,0.453,0.600,-3.087,0.000,0.147,0.000,-0.989",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.347,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.807000160217285,
            "data": [
                "prisoner,0.446,0.600,-3.088,0.000,0.128,0.000,-0.992",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.347,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.822999954223633,
            "data": [
                "prisoner,0.438,0.600,-3.089,0.000,0.111,0.000,-0.994",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.347,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.841000080108643,
            "data": [
                "prisoner,0.432,0.600,-3.089,0.000,0.095,0.000,-0.995",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.347,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.857999801635742,
            "data": [
                "prisoner,0.424,0.600,-3.090,0.000,0.077,0.000,-0.997",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.347,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.869999885559082,
            "data": [
                "prisoner,0.418,0.600,-3.091,0.000,0.063,0.000,-0.998",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.347,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.883999824523926,
            "data": [
                "prisoner,0.414,0.600,-3.091,0.000,0.052,0.000,-0.999",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.347,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.900000095367432,
            "data": [
                "prisoner,0.410,0.600,-3.091,0.000,0.042,0.000,-0.999",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.347,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.914999961853027,
            "data": [
                "prisoner,0.406,0.600,-3.092,0.000,0.032,0.000,-0.999",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.347,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.931000232696533,
            "data": [
                "prisoner,0.402,0.600,-3.092,0.000,0.023,0.000,-1.000",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.347,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.951000213623047,
            "data": [
                "prisoner,0.399,0.600,-3.092,0.000,0.015,0.000,-1.000",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.347,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.966000080108643,
            "data": [
                "prisoner,0.396,0.600,-3.093,0.000,0.008,0.000,-1.000",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.347,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.979000091552734,
            "data": [
                "prisoner,0.395,0.600,-3.093,0.000,0.004,0.000,-1.000",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.347,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 7.99399995803833,
            "data": [
                "prisoner,0.394,0.600,-3.093,0.000,0.002,0.000,-1.000",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.347,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        },
        {
            "time": 8.010000228881836,
            "data": [
                "prisoner,0.393,0.600,-3.093,0.000,0.000,0.000,-1.000",
                "victimM,1.547,0.600,-2.238,0.138,-0.699,0.687,0.140",
                "citizenF,0.964,0.600,-3.347,0.000,0.000,0.000,1.000",
                "observationCamera,1.900,0.906,-2.916,0.059,-0.757,0.069,0.647"
            ]
        }
    ]
};
